import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useParticipante } from '../../../contexts/ParticipanteContext';
import { PixModal } from '../../../components/premiado/PixModal';
import { PagamentoContaModal } from '../../../components/premiado/PagamentoContaModal';
import { PixPersonalizadoModal } from '../../../components/premiado/PixPersonalizadoModal';
import { PagamentoPersonalizadoModal } from '../../../components/premiado/PagamentoPersonalizadoModal';
import { calcularPontosFinanceiro } from '../../../utils/pontosFinanceiro';
import { creditosFinanceiros, CreditoFinanceiro } from '../../../mocks/creditosFinanceiros';
import ComprovanteResgateModal from './components/ComprovanteResgateModal';
import FinancialCard from './components/FinancialCard';
import PixPagamentoCard from './components/PixPagamentoCard';
import MeusResgates from './components/MeusResgates';

type AbaRecompensa = 'financeira' | 'produtos' | 'vouchers' | 'experiencias' | 'cursos' | 'resgates';

// Tipos para o Tour Virtual
interface TourStep {
  target: string;
  title: string;
  description: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  action?: () => void;
}

export default function ParticipanteRecompensas() {
  const { participante, campanhaAtual } = useParticipante();

  // Pontos disponíveis: usa a campanha atual se disponível, senão fallback para o participante
  const pontosDisponiveis = campanhaAtual?.progressao?.pontosDisponiveis ?? participante?.pontosDisponiveis ?? 0;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const abaParam = searchParams.get('aba');
  const [abaSelecionada, setAbaSelecionada] = useState<AbaRecompensa>(abaParam === 'resgates' ? 'resgates' : 'financeira');
  const [modalPixAberto, setModalPixAberto] = useState(false);
  const [modalPagamentoAberto, setModalPagamentoAberto] = useState(false);
  const [modalCashbackAberto, setModalCashbackAberto] = useState(false);
  const [modalPixPersonalizadoAberto, setModalPixPersonalizadoAberto] = useState(false);
  const [modalPagamentoPersonalizadoAberto, setModalPagamentoPersonalizadoAberto] = useState(false);
  const [creditoPixPersonalizado, setCreditoPixPersonalizado] = useState<CreditoFinanceiro | undefined>(undefined);
  const [creditoPagamentoPersonalizado, setCreditoPagamentoPersonalizado] = useState<CreditoFinanceiro | undefined>(undefined);
  const [infoCardVisivel, setInfoCardVisivel] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setInfoCardVisivel(false), 40_000);
    return () => clearTimeout(timer);
  }, []);

  // Estados de busca e categoria (aba produtos)
  const [buscaProduto, setBuscaProduto] = useState('');
  const [categoriaProduto, setCategoriaProduto] = useState('todos');

  // Estados de busca e categoria (aba vouchers)
  const [buscaVoucher, setBuscaVoucher] = useState('');
  const [categoriaVoucher, setCategoriaVoucher] = useState('todos');

  // Estados do Tour Virtual
  const [tourAtivo, setTourAtivo] = useState(false);
  const [passoAtual, setPassoAtual] = useState(0);
  const [tipoTour, setTipoTour] = useState<'pix' | 'pagamento' | null>(null);

  // Estados do modal de resgate de produto
  const [modalResgateProduto, setModalResgateProduto] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState<any>(null);
  const [etapaResgate, setEtapaResgate] = useState<'endereco' | 'confirmacao' | 'token' | 'sucesso'>('endereco');
  const [enderecoEntrega, setEnderecoEntrega] = useState({
    nome: 'João Silva',
    cep: '01310-100',
    logradouro: 'Av. Paulista',
    numero: '1000',
    complemento: 'Apto 42',
    bairro: 'Bela Vista',
    cidade: 'São Paulo',
    estado: 'SP'
  });
  const [freteOpcao, setFreteOpcao] = useState<'normal' | 'expresso'>('normal');

  // Estados do modal de resgate de voucher
  const [modalResgateVoucher, setModalResgateVoucher] = useState(false);
  const [voucherSelecionado, setVoucherSelecionado] = useState<any>(null);
  const [etapaResgateVoucher, setEtapaResgateVoucher] = useState<'valor' | 'contato' | 'confirmacao' | 'token' | 'sucesso'>('contato');
  const [valorVoucherSelecionado, setValorVoucherSelecionado] = useState<{ label: string; pontos: number } | null>(null);
  const [contatoVoucher, setContatoVoucher] = useState({
    email: 'joao.silva@email.com',
    whatsapp: '(11) 99999-9999',
    canaisEnvio: { email: true, whatsapp: false }
  });
  const [codigoVoucherGerado, setCodigoVoucherGerado] = useState('');

  // Estado dos resgates dinâmicos (produtos resgatados pelo usuário)
  const [resgatesDinamicos, setResgatesDinamicos] = useState<any[]>([]);

  // Estado do modal de comprovante
  const [comprovanteResgate, setComprovanteResgate] = useState<any>(null);

  // Estados de crédito selecionado para produto e voucher
  const [creditoSelecionadoProduto, setCreditoSelecionadoProduto] = useState<string>('');
  const [creditoSelecionadoVoucher, setCreditoSelecionadoVoucher] = useState<string>('');

  // Modal de resgate genérico para Experiências e Cursos
  const [modalResgateGenerico, setModalResgateGenerico] = useState(false);
  const [itemGenericoSelecionado, setItemGenericoSelecionado] = useState<any>(null);
  const [tipoItemGenerico, setTipoItemGenerico] = useState<'experiencia' | 'curso'>('experiencia');
  const [etapaGenerico, setEtapaGenerico] = useState<'credito' | 'token' | 'sucesso'>('credito');
  const [creditoSelecionadoGenerico, setCreditoSelecionadoGenerico] = useState<string>('');
  const [tokenGenerico, setTokenGenerico] = useState('');
  const [tokenGenericoErro, setTokenGenericoErro] = useState('');
  const [reenvioCountdownGenerico, setReenvioCountdownGenerico] = useState(0);

  // Definir os passos do tour PIX - COMPLETO COM TODOS OS PASSOS DO FORMULÁRIO
  const tourStepsPix: TourStep[] = [
    {
      target: '[data-tour="aba-financeira"]',
      title: 'Passo 1: Categoria Financeira',
      description: 'Primeiro, certifique-se de estar na aba "Financeira" onde estão as opções de resgate financeiro.',
      position: 'bottom'
    },
    {
      target: '[data-tour="card-pix"]',
      title: 'Passo 2: Selecione PIX',
      description: 'Este é o card do PIX. Aqui você pode transferir seus pontos diretamente para sua conta bancária.',
      position: 'top'
    },
    {
      target: '[data-tour="btn-resgatar-pix"]',
      title: 'Passo 3: Clique em Resgatar',
      description: 'Clique no botão "Resgatar Agora" para abrir o formulário de resgate PIX.',
      position: 'top',
      action: () => {
        setModalPixAberto(true);
      }
    },
    {
      target: '[data-tour="pix-credito-select"]',
      title: 'Passo 4: Selecione o Crédito',
      description: 'Escolha qual crédito você deseja resgatar. Cada crédito tem um valor específico de uma campanha.',
      position: 'bottom'
    },
    {
      target: '[data-tour="pix-tipo-chave"]',
      title: 'Passo 5: Tipo de Chave PIX',
      description: 'Selecione o tipo da sua chave PIX: CPF/CNPJ, E-mail, Celular ou Chave Aleatória.',
      position: 'bottom'
    },
    {
      target: '[data-tour="pix-chave-input"]',
      title: 'Passo 6: Digite sua Chave PIX',
      description: 'Informe a chave PIX para onde deseja receber o valor. Confira se está correta!',
      position: 'bottom'
    },
    {
      target: '[data-tour="pix-descricao"]',
      title: 'Passo 7: Descrição (Opcional)',
      description: 'Se quiser, adicione uma descrição para identificar esta transferência no seu extrato.',
      position: 'top'
    },
    {
      target: '[data-tour="pix-btn-continuar"]',
      title: 'Passo 8: Continuar',
      description: 'Clique em "Continuar" para revisar todos os dados antes de confirmar a transferência.',
      position: 'top'
    },
    {
      target: '[data-tour="pix-btn-confirmar"]',
      title: 'Passo 9: Confirme a Transferência',
      description: 'Revise todos os dados cuidadosamente e clique em "Confirmar PIX" para finalizar o resgate!',
      position: 'top'
    }
  ];

  // Definir os passos do tour Pagamento - COMPLETO COM TODOS OS PASSOS DO FORMULÁRIO
  const tourStepsPagamento: TourStep[] = [
    {
      target: '[data-tour="aba-financeira"]',
      title: 'Passo 1: Categoria Financeira',
      description: 'Primeiro, certifique-se de estar na aba "Financeira" onde estão as opções de resgate financeiro.',
      position: 'bottom'
    },
    {
      target: '[data-tour="card-pagamento"]',
      title: 'Passo 2: Pagamento de Contas',
      description: 'Este é o card de Pagamento de Contas. Aqui você pode pagar boletos e contas usando seus pontos.',
      position: 'top'
    },
    {
      target: '[data-tour="btn-resgatar-pagamento"]',
      title: 'Passo 3: Clique em Resgatar',
      description: 'Clique no botão "Resgatar Agora" para abrir o formulário de pagamento de contas.',
      position: 'top',
      action: () => {
        setModalPagamentoAberto(true);
      }
    },
    {
      target: '[data-tour="pagamento-credito-select"]',
      title: 'Passo 4: Selecione o Crédito',
      description: 'Escolha qual crédito você deseja usar para pagar a conta. O valor do crédito deve cobrir o valor da conta.',
      position: 'bottom'
    },
    {
      target: '[data-tour="pagamento-tipo"]',
      title: 'Passo 5: Tipo de Pagamento',
      description: 'Selecione se é um Boleto bancário ou uma Conta de Consumo (luz, água, gás, telefone, etc).',
      position: 'bottom'
    },
    {
      target: '[data-tour="pagamento-codigo"]',
      title: 'Passo 6: Código de Barras',
      description: 'Digite ou cole o código de barras da conta. Você também pode usar o scanner de câmera para facilitar.',
      position: 'bottom'
    },
    {
      target: '[data-tour="pagamento-btn-validar"]',
      title: 'Passo 7: Validar Código',
      description: 'Clique em "Validar Código" para verificar os dados da conta antes de pagar. O sistema irá buscar as informações do beneficiário e valor.',
      position: 'top'
    },
    {
      target: '[data-tour="pagamento-btn-continuar"]',
      title: 'Passo 8: Continuar',
      description: 'Após validar os dados da conta, clique em "Continuar" para revisar todas as informações do pagamento.',
      position: 'top'
    },
    {
      target: '[data-tour="pagamento-btn-confirmar"]',
      title: 'Passo 9: Confirme o Pagamento',
      description: 'Revise todos os dados cuidadosamente e clique em "Confirmar Pagamento" para finalizar! O pagamento será processado imediatamente.',
      position: 'top'
    }
  ];

  // Listener para iniciar o tour
  useEffect(() => {
    const handleStartTour = (event: Event) => {
      const customEvent = event as CustomEvent;
      const { type } = customEvent.detail;
      console.log('🎯 Tour iniciado:', type);
      
      // Garantir que estamos na aba financeira
      setAbaSelecionada('financeira');
      
      // Definir o tipo de tour e iniciar
      setTipoTour(type);
      setPassoAtual(0);
      setTourAtivo(true);
    };

    window.addEventListener('startGuidedTour', handleStartTour);

    return () => {
      window.removeEventListener('startGuidedTour', handleStartTour);
    };
  }, []);

  // Obter os passos do tour atual
  const getTourSteps = (): TourStep[] => {
    if (tipoTour === 'pix') return tourStepsPix;
    if (tipoTour === 'pagamento') return tourStepsPagamento;
    return [];
  };

  const tourSteps = getTourSteps();
  const stepAtual = tourSteps[passoAtual];

  // Funções de navegação do tour
  const proximoPasso = () => {
    // Executar ação do passo atual (se houver) - como abrir modal
    if (stepAtual?.action) {
      stepAtual.action();
      
      // Se a ação abre um modal, aguardar renderização antes de avançar
      setTimeout(() => {
        if (passoAtual < tourSteps.length - 1) {
          setPassoAtual(passoAtual + 1);
        } else {
          finalizarTour();
        }
      }, 500); // Aguardar modal renderizar
    } else {
      // Sem ação, avançar normalmente
      if (passoAtual < tourSteps.length - 1) {
        setPassoAtual(passoAtual + 1);
      } else {
        finalizarTour();
      }
    }
  };

  const passoAnterior = () => {
    if (passoAtual > 0) {
      setPassoAtual(passoAtual - 1);
    }
  };

  const finalizarTour = () => {
    setTourAtivo(false);
    setPassoAtual(0);
    setTipoTour(null);
    // Fechar modais ao finalizar tour
    setModalPixAberto(false);
    setModalPagamentoAberto(false);
  };

  // Efeito para destacar o elemento atual do tour
  useEffect(() => {
    if (!tourAtivo || !stepAtual) return;

    // Função para tentar encontrar e destacar o elemento
    const tentarDestacar = (tentativas = 0) => {
      const elemento = document.querySelector(stepAtual.target);
      
      if (elemento) {
        elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (tentativas < 10) {
        // Se elemento não encontrado, tentar novamente (pode estar carregando)
        setTimeout(() => tentarDestacar(tentativas + 1), 200);
      }
    };

    tentarDestacar();
  }, [tourAtivo, passoAtual, stepAtual]);

  // Dados das abas
  const abas = [
    { id: 'financeira' as AbaRecompensa, nome: 'Financeira', icone: 'ri-bank-card-line' },
    { id: 'produtos' as AbaRecompensa, nome: 'Produtos', icone: 'ri-shopping-bag-line' },
    { id: 'vouchers' as AbaRecompensa, nome: 'Vouchers', icone: 'ri-coupon-line' },
    { id: 'experiencias' as AbaRecompensa, nome: 'Experiências', icone: 'ri-compass-3-line' },
    { id: 'cursos' as AbaRecompensa, nome: 'Cursos', icone: 'ri-graduation-cap-line' },
    { id: 'resgates' as AbaRecompensa, nome: 'Meus Resgates', icone: 'ri-history-line' }
  ];

  // Dados dos serviços financeiros
  const servicosFinanceiros = [
    {
      id: 'pix',
      nome: 'PIX',
      descricao: 'Transfira seus pontos diretamente para sua conta bancária via PIX',
      imagem: 'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/d0bca9b579fa5bbed4a08ef0669cd18f.png',
      pontos: 0,
      disponivel: true,
      destaque: true,
      tags: ['Instantâneo', 'Sem taxas'],
      exemploValor: 100,
    },
    {
      id: 'pagamento-contas',
      nome: 'Pagamento de Contas',
      descricao: 'Pague suas contas e boletos usando seus pontos acumulados',
      imagem: 'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/32c6fb1e1592b974c4b053fbb384b0c1.png',
      pontos: 0,
      disponivel: true,
      destaque: false,
      tags: ['Boletos', 'Contas'],
      exemploValor: 200,
    },
    ...creditosFinanceiros.map((credito) => ({
      id: `pix-personalizado-${credito.id}`,
      nome: `PIX — ${credito.descricao}`,
      descricao: `Campanha: ${credito.campanha} • Resgate via PIX com valor personalizado`,
      imagem: 'https://readdy.ai/api/search-image?query=digital%20payment%20pix%20transfer%20smartphone%20app%20clean%20minimal%20interface%20green%20teal%20background%20professional&width=400&height=300&seq=pixcustom1&orientation=landscape',
      pontos: 0,
      disponivel: true,
      destaque: false,
      tags: ['PIX Personalizado', credito.campanha],
      exemploValor: credito.valor,
      personalizado: true,
      creditoValor: credito.valor,
      creditoNome: credito.descricao,
    })),
    ...creditosFinanceiros.map((credito) => ({
      id: `pagamento-personalizado-${credito.id}`,
      nome: `Pagamento — ${credito.descricao}`,
      descricao: `Campanha: ${credito.campanha} • Pagamento de contas com valor personalizado`,
      imagem: 'https://readdy.ai/api/search-image?query=bill%20payment%20digital%20banking%20app%20clean%20minimal%20interface%20teal%20cyan%20background%20professional%20modern&width=400&height=300&seq=pagcustom1&orientation=landscape',
      pontos: 0,
      disponivel: true,
      destaque: false,
      tags: ['Pagamento Personalizado', credito.campanha],
      exemploValor: credito.valor,
      personalizado: true,
      creditoValor: credito.valor,
      creditoNome: credito.descricao,
    })),
    {
      id: 'cashback',
      nome: 'Cashback',
      descricao: 'Receba de volta parte dos seus pontos em compras parceiras',
      imagem: 'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/9efecf4d720f800189f4073a3af54c3a.png',
      pontos: 0,
      disponivel: true,
      destaque: false,
      tags: ['Economia', 'Vantagens'],
      exemploValor: 0,
    }
  ];

  // Dados dos produtos
  const produtos = [
    {
      id: 'smartphone',
      nome: 'Smartphone Galaxy S23',
      descricao: 'Smartphone top de linha com câmera de 200MP e 5G',
      imagem: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?w=400&h=300&fit=crop&q=80',
      pontos: 50000,
      disponivel: true,
      destaque: true,
      tags: ['Eletrônicos', 'Top'],
      categoria: 'eletronicos'
    },
    {
      id: 'notebook',
      nome: 'Notebook Dell Inspiron',
      descricao: 'Notebook com Intel i7, 16GB RAM e SSD 512GB',
      imagem: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400&h=300&fit=crop&q=80',
      pontos: 80000,
      disponivel: true,
      destaque: false,
      tags: ['Eletrônicos', 'Trabalho'],
      categoria: 'eletronicos'
    },
    {
      id: 'fone',
      nome: 'Fone Bluetooth Premium',
      descricao: 'Fone de ouvido com cancelamento de ruído ativo',
      imagem: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=300&fit=crop&q=80',
      pontos: 15000,
      disponivel: true,
      destaque: false,
      tags: ['Áudio', 'Bluetooth'],
      categoria: 'eletronicos'
    },
    {
      id: 'cafeteira',
      nome: 'Cafeteira Nespresso',
      descricao: 'Máquina de café expresso automática com 19 bar de pressão',
      imagem: 'https://readdy.ai/api/search-image?query=nespresso%20coffee%20machine%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=cafe1&orientation=landscape',
      pontos: 12000,
      disponivel: true,
      destaque: false,
      tags: ['Casa', 'Cozinha'],
      categoria: 'casa'
    },
    {
      id: 'airfryer',
      nome: 'Air Fryer Philips',
      descricao: 'Fritadeira elétrica sem óleo, 4.1L, timer e controle de temperatura',
      imagem: 'https://readdy.ai/api/search-image?query=philips%20air%20fryer%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=af1&orientation=landscape',
      pontos: 7000,
      disponivel: true,
      destaque: false,
      tags: ['Casa', 'Cozinha'],
      categoria: 'casa'
    },
    {
      id: 'tenis',
      nome: 'Tênis Nike Air Max',
      descricao: 'Tênis esportivo com tecnologia Air Max e design moderno',
      imagem: 'https://readdy.ai/api/search-image?query=nike%20air%20max%20sneakers%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=tn1&orientation=landscape',
      pontos: 9000,
      disponivel: true,
      destaque: true,
      tags: ['Moda', 'Esporte'],
      categoria: 'moda'
    },
    {
      id: 'mochila',
      nome: 'Mochila Executiva',
      descricao: 'Mochila para notebook até 15.6" com compartimentos organizadores',
      imagem: 'https://readdy.ai/api/search-image?query=executive%20laptop%20backpack%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=mb1&orientation=landscape',
      pontos: 4000,
      disponivel: true,
      destaque: false,
      tags: ['Moda', 'Trabalho'],
      categoria: 'moda'
    },
    {
      id: 'perfume',
      nome: 'Perfume Importado 100ml',
      descricao: 'Fragrância masculina sofisticada com notas amadeiradas',
      imagem: 'https://readdy.ai/api/search-image?query=luxury%20mens%20perfume%20bottle%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=pf1&orientation=landscape',
      pontos: 4500,
      disponivel: true,
      destaque: false,
      tags: ['Beleza', 'Cuidados'],
      categoria: 'beleza'
    },
    {
      id: 'skincare',
      nome: 'Kit Skincare Facial',
      descricao: 'Kit completo para cuidados faciais com 4 produtos premium',
      imagem: 'https://readdy.ai/api/search-image?query=facial%20skincare%20kit%20products%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=sk1&orientation=landscape',
      pontos: 3800,
      disponivel: true,
      destaque: false,
      tags: ['Beleza', 'Cuidados'],
      categoria: 'beleza'
    }
  ];

  // Dados dos vouchers
  const vouchers = [
    {
      id: 'amazon',
      nome: 'Vale Amazon',
      descricao: 'Crédito para usar em qualquer compra na Amazon',
      imagem: 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?w=400&h=300&fit=crop&q=80',
      pontos: 10000,
      disponivel: true,
      destaque: true,
      tags: ['E-commerce', 'Popular'],
      categoria: 'ecommerce',
      valores: [
        { label: 'R$ 50', pontos: 5000 },
        { label: 'R$ 100', pontos: 10000 },
        { label: 'R$ 200', pontos: 19000 },
        { label: 'R$ 500', pontos: 46000 },
      ]
    },
    {
      id: 'ifood',
      nome: 'Vale iFood R$ 50',
      descricao: 'Crédito para pedidos de comida no iFood',
      imagem: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&h=300&fit=crop&q=80',
      pontos: 5000,
      disponivel: true,
      destaque: false,
      tags: ['Alimentação', 'Delivery'],
      categoria: 'alimentacao'
    },
    {
      id: 'uber',
      nome: 'Vale Uber',
      descricao: 'Crédito para corridas de Uber',
      imagem: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=400&h=300&fit=crop&q=80',
      pontos: 3000,
      disponivel: true,
      destaque: false,
      tags: ['Transporte', 'Mobilidade'],
      categoria: 'transporte',
      valores: [
        { label: 'R$ 30', pontos: 3000 },
        { label: 'R$ 60', pontos: 5800 },
        { label: 'R$ 100', pontos: 9500 },
      ]
    },
    {
      id: 'netflix',
      nome: 'Netflix 1 Mês',
      descricao: 'Assinatura de 1 mês do plano padrão Netflix',
      imagem: 'https://readdy.ai/api/search-image?query=netflix%20streaming%20service%20logo%20on%20dark%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=nf1&orientation=landscape',
      pontos: 4000,
      disponivel: true,
      destaque: false,
      tags: ['Entretenimento', 'Streaming'],
      categoria: 'entretenimento'
    },
    {
      id: 'spotify',
      nome: 'Spotify Premium 3 Meses',
      descricao: 'Ouça músicas sem anúncios por 3 meses',
      imagem: 'https://readdy.ai/api/search-image?query=spotify%20music%20streaming%20app%20on%20clean%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=sp1&orientation=landscape',
      pontos: 3500,
      disponivel: true,
      destaque: false,
      tags: ['Entretenimento', 'Música'],
      categoria: 'entretenimento'
    },
    {
      id: 'rappi',
      nome: 'Vale Rappi R$ 40',
      descricao: 'Crédito para delivery de comida, mercado e farmácia',
      imagem: 'https://readdy.ai/api/search-image?query=food%20delivery%20app%20on%20smartphone%20clean%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=rp1&orientation=landscape',
      pontos: 4000,
      disponivel: true,
      destaque: false,
      tags: ['Alimentação', 'Delivery'],
      categoria: 'alimentacao'
    },
    {
      id: 'magazine',
      nome: 'Vale Magazine Luiza',
      descricao: 'Crédito para compras no site ou lojas Magazine Luiza',
      imagem: 'https://readdy.ai/api/search-image?query=retail%20store%20shopping%20voucher%20on%20clean%20white%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=ml1&orientation=landscape',
      pontos: 15000,
      disponivel: true,
      destaque: true,
      tags: ['E-commerce', 'Varejo'],
      categoria: 'ecommerce',
      valores: [
        { label: 'R$ 50', pontos: 5000 },
        { label: 'R$ 100', pontos: 9500 },
        { label: 'R$ 150', pontos: 14000 },
        { label: 'R$ 300', pontos: 27000 },
      ]
    },
    {
      id: '99taxi',
      nome: 'Vale 99 R$ 25',
      descricao: 'Crédito para corridas de táxi e moto pelo app 99',
      imagem: 'https://readdy.ai/api/search-image?query=taxi%20ride%20app%20on%20smartphone%20clean%20background%2C%20professional%20product%20photography%2C%20high%20quality%2C%20centered%20composition&width=400&height=300&seq=tx1&orientation=landscape',
      pontos: 2500,
      disponivel: true,
      destaque: false,
      tags: ['Transporte', 'Táxi'],
      categoria: 'transporte'
    }
  ];

  // Dados das experiências
  const experiencias = [
    {
      id: 'spa',
      nome: 'Day Spa Completo',
      descricao: 'Um dia inteiro de relaxamento com massagens e tratamentos',
      imagem: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400&h=300&fit=crop&q=80',
      pontos: 25000,
      disponivel: true,
      destaque: true,
      tags: ['Bem-estar', 'Relaxamento']
    },
    {
      id: 'jantar',
      nome: 'Jantar Romântico',
      descricao: 'Jantar para 2 pessoas em restaurante premium',
      imagem: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop&q=80',
      pontos: 18000,
      disponivel: true,
      destaque: false,
      tags: ['Gastronomia', 'Romance']
    },
    {
      id: 'aventura',
      nome: 'Parque de Aventuras',
      descricao: 'Dia completo em parque de aventuras com tirolesa e arvorismo',
      imagem: 'https://images.unsplash.com/photo-1476610182048-b716b8518aae?w=400&h=300&fit=crop&q=80',
      pontos: 20000,
      disponivel: true,
      destaque: false,
      tags: ['Aventura', 'Esportes']
    }
  ];

  // Dados dos cursos
  const cursos = [
    {
      id: 'ingles',
      nome: 'Curso de Inglês Online',
      descricao: 'Curso completo de inglês com certificado reconhecido',
      imagem: 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=400&h=300&fit=crop&q=80',
      pontos: 30000,
      disponivel: true,
      destaque: true,
      tags: ['Idiomas', 'Online']
    },
    {
      id: 'excel',
      nome: 'Excel Avançado',
      descricao: 'Domine fórmulas, tabelas dinâmicas e macros',
      imagem: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop&q=80',
      pontos: 12000,
      disponivel: true,
      destaque: false,
      tags: ['Produtividade', 'Negócios']
    },
    {
      id: 'marketing',
      nome: 'Marketing Digital',
      descricao: 'Aprenda estratégias de marketing digital e redes sociais',
      imagem: 'https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?w=400&h=300&fit=crop&q=80',
      pontos: 22000,
      disponivel: true,
      destaque: false,
      tags: ['Marketing', 'Digital']
    }
  ];

  // Histórico de resgates (base + dinâmicos)
  const historicoResgatesBase = [
    {
      id: '1',
      item: 'PIX - Transferência',
      tipo: 'financeiro',
      pontos: 5000,
      data: '2024-01-15',
      status: 'concluido',
      valor: 'R$ 50,00',
      chavePix: '***@gmail.com',
      creditoId: 'credito-1'
    },
    {
      id: '2',
      item: 'Fone Bluetooth Premium',
      tipo: 'produto',
      pontos: 15000,
      data: '2024-01-10',
      status: 'em_transito',
      rastreio: 'BR123456789BR',
      transportadora: 'Correios',
      previsaoEntrega: '2024-01-20',
      creditoId: 'credito-2'
    },
    {
      id: '3',
      item: 'Vale Amazon R$ 100',
      tipo: 'voucher',
      pontos: 10000,
      data: '2024-01-05',
      status: 'utilizado',
      codigo: 'AMZ-XXXX-YYYY-ZZZZ'
    },
    {
      id: '4',
      item: 'Curso de Inglês Online',
      tipo: 'curso',
      pontos: 30000,
      data: '2024-01-01',
      status: 'ativo',
      acesso: 'https://plataforma.com/curso',
      validade: '2024-12-31',
      creditoId: 'credito-3'
    }
  ];

  const historicoResgates = [...resgatesDinamicos, ...historicoResgatesBase];

  // Estados de token
  const [tokenProduto, setTokenProduto] = useState('');
  const [tokenVoucher, setTokenVoucher] = useState('');
  const [tokenProdutoErro, setTokenProdutoErro] = useState('');
  const [tokenVoucherErro, setTokenVoucherErro] = useState('');
  const [tokenProdutoEnviado, setTokenProdutoEnviado] = useState(false);
  const [tokenVoucherEnviado, setTokenVoucherEnviado] = useState(false);
  const [reenvioCountdownProduto, setReenvioCountdownProduto] = useState(0);
  const [reenvioCountdownVoucher, setReenvioCountdownVoucher] = useState(0);

  const categoriasVouchers = [
    { id: 'todos', nome: 'Todos', icone: 'ri-apps-line' },
    { id: 'ecommerce', nome: 'E-commerce', icone: 'ri-shopping-cart-line' },
    { id: 'alimentacao', nome: 'Alimentação', icone: 'ri-restaurant-line' },
    { id: 'transporte', nome: 'Transporte', icone: 'ri-car-line' },
    { id: 'entretenimento', nome: 'Entretenimento', icone: 'ri-film-line' },
  ];

  const vouchersFiltrados = vouchers.filter((v) => {
    const matchCategoria = categoriaVoucher === 'todos' || v.categoria === categoriaVoucher;
    const matchBusca =
      buscaVoucher.trim() === '' ||
      v.nome.toLowerCase().includes(buscaVoucher.toLowerCase()) ||
      v.descricao.toLowerCase().includes(buscaVoucher.toLowerCase()) ||
      v.tags.some((t) => t.toLowerCase().includes(buscaVoucher.toLowerCase()));
    return matchCategoria && matchBusca;
  });

  const categoriasProdutos = [
    { id: 'todos', nome: 'Todos', icone: 'ri-apps-line' },
    { id: 'eletronicos', nome: 'Eletrônicos', icone: 'ri-smartphone-line' },
    { id: 'casa', nome: 'Casa', icone: 'ri-home-line' },
    { id: 'moda', nome: 'Moda', icone: 'ri-t-shirt-line' },
    { id: 'beleza', nome: 'Beleza', icone: 'ri-heart-line' },
  ];

  const produtosFiltrados = produtos.filter((p) => {
    const matchCategoria = categoriaProduto === 'todos' || p.categoria === categoriaProduto;
    const matchBusca =
      buscaProduto.trim() === '' ||
      p.nome.toLowerCase().includes(buscaProduto.toLowerCase()) ||
      p.descricao.toLowerCase().includes(buscaProduto.toLowerCase()) ||
      p.tags.some((t) => t.toLowerCase().includes(buscaProduto.toLowerCase()));
    return matchCategoria && matchBusca;
  });

  const getRecompensasAtuais = () => {
    switch (abaSelecionada) {
      case 'financeira':
        return servicosFinanceiros;
      case 'produtos':
        return produtosFiltrados;
      case 'vouchers':
        return vouchersFiltrados;
      case 'experiencias':
        return experiencias;
      case 'cursos':
        return cursos;
      default:
        return [];
    }
  };

  const handleAbrirResgateProduto = (produto: any) => {
    if (pontosDisponiveis < produto.pontos) return;
    setProdutoSelecionado(produto);
    setEtapaResgate('endereco');
    setFreteOpcao('normal');
    setCreditoSelecionadoProduto('');
    setModalResgateProduto(true);
  };

  const handleConfirmarEndereco = () => {
    setEtapaResgate('confirmacao');
  };

  const handleConfirmarResgate = () => {
    // Avança para etapa de token
    setTokenProduto('');
    setTokenProdutoErro('');
    setTokenProdutoEnviado(true);
    setReenvioCountdownProduto(60);
    setEtapaResgate('token');
  };

  const handleValidarTokenProduto = () => {
    if (tokenProduto.length !== 6) {
      setTokenProdutoErro('Digite o código de 6 dígitos enviado.');
      return;
    }
    // Simula validação (aceita qualquer código de 6 dígitos)
    const frete = freteOpcoes[freteOpcao];
    const codigo = gerarCodigoRastreio();
    const hoje = new Date();
    const diasPrazo = freteOpcao === 'expresso' ? 4 : 12;
    const previsao = new Date(hoje);
    previsao.setDate(previsao.getDate() + diasPrazo);

    const novoResgate = {
      id: `prod-${Date.now()}`,
      item: produtoSelecionado.nome,
      tipo: 'produto',
      pontos: produtoSelecionado.pontos + (freteOpcao === 'expresso' ? frete.pontos : 0),
      data: hoje.toISOString().split('T')[0],
      status: 'em_transito',
      rastreio: codigo,
      transportadora: frete.transportadora,
      previsaoEntrega: previsao.toISOString().split('T')[0],
      enderecoEntrega: `${enderecoEntrega.logradouro}, ${enderecoEntrega.numero} - ${enderecoEntrega.bairro}, ${enderecoEntrega.cidade}/${enderecoEntrega.estado}`
    };

    setResgatesDinamicos(prev => [novoResgate, ...prev]);
    setTokenProdutoErro('');
    setEtapaResgate('sucesso');
  };

  const handleReenviarTokenProduto = () => {
    setTokenProduto('');
    setTokenProdutoErro('');
    setTokenProdutoEnviado(true);
    setReenvioCountdownProduto(60);
  };

  const handleFecharModalResgate = () => {
    setModalResgateProduto(false);
    setProdutoSelecionado(null);
    setEtapaResgate('endereco');
    setTokenProduto('');
    setTokenProdutoErro('');
    setTokenProdutoEnviado(false);
    setReenvioCountdownProduto(0);
  };

  const handleVerMeusResgates = () => {
    handleFecharModalResgate();
    setAbaSelecionada('resgates');
  };

  const handleAbrirResgateVoucher = (voucher: any) => {
    if (pontosDisponiveis < voucher.pontos) return;
    setVoucherSelecionado(voucher);
    setValorVoucherSelecionado(null);
    setEtapaResgateVoucher(voucher.valores ? 'valor' : 'contato');
    setContatoVoucher({
      email: 'joao.silva@email.com',
      whatsapp: '(11) 99999-9999',
      canaisEnvio: { email: true, whatsapp: false }
    });
    setCodigoVoucherGerado('');
    setCreditoSelecionadoVoucher('');
    setModalResgateVoucher(true);
  };

  const handleConfirmarContatoVoucher = () => {
    if (!contatoVoucher.canaisEnvio.email && !contatoVoucher.canaisEnvio.whatsapp) return;
    setEtapaResgateVoucher('confirmacao');
  };

  const gerarCodigoVoucher = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < 16; i++) {
      if (i > 0 && i % 4 === 0) code += '-';
      code += chars[Math.floor(Math.random() * chars.length)];
    }
    return code;
  };

  const handleConfirmarResgateVoucher = () => {
    // Avança para etapa de token
    setTokenVoucher('');
    setTokenVoucherErro('');
    setTokenVoucherEnviado(true);
    setReenvioCountdownVoucher(60);
    setEtapaResgateVoucher('token');
  };

  const handleValidarTokenVoucher = () => {
    if (tokenVoucher.length !== 6) {
      setTokenVoucherErro('Digite o código de 6 dígitos enviado.');
      return;
    }
    const codigo = gerarCodigoVoucher();
    setCodigoVoucherGerado(codigo);

    const canais: string[] = [];
    if (contatoVoucher.canaisEnvio.email) canais.push('email');
    if (contatoVoucher.canaisEnvio.whatsapp) canais.push('whatsapp');

    const novoResgate = {
      id: `voucher-${Date.now()}`,
      item: voucherSelecionado.nome,
      tipo: 'voucher',
      pontos: voucherSelecionado.pontos,
      data: new Date().toISOString().split('T')[0],
      status: 'utilizado',
      codigo,
      canaisEnvio: canais
    };

    setResgatesDinamicos(prev => [novoResgate, ...prev]);
    setTokenVoucherErro('');
    setEtapaResgateVoucher('sucesso');
  };

  const handleReenviarTokenVoucher = () => {
    setTokenVoucher('');
    setTokenVoucherErro('');
    setTokenVoucherEnviado(true);
    setReenvioCountdownVoucher(60);
  };

  const handleFecharModalVoucher = () => {
    setModalResgateVoucher(false);
    setVoucherSelecionado(null);
    setEtapaResgateVoucher('contato');
    setValorVoucherSelecionado(null);
    setTokenVoucher('');
    setTokenVoucherErro('');
    setTokenVoucherEnviado(false);
    setReenvioCountdownVoucher(0);
  };

  const handleVerResgatesVoucher = () => {
    handleFecharModalVoucher();
    setAbaSelecionada('resgates');
  };

  const handleResgatar = (item: any) => {
    if (item.id === 'pix') {
      setModalPixAberto(true);
    } else if (item.id === 'pagamento-contas') {
      setModalPagamentoAberto(true);
    } else if (item.id && (item.id as string).startsWith('pix-personalizado-')) {
      const creditoId = (item.id as string).replace('pix-personalizado-', '');
      const credito = creditosFinanceiros.find((c) => c.id === creditoId);
      setCreditoPixPersonalizado(credito);
      setModalPixPersonalizadoAberto(true);
    } else if (item.id === 'pix-personalizado') {
      setCreditoPixPersonalizado(undefined);
      setModalPixPersonalizadoAberto(true);
    } else if (item.id && (item.id as string).startsWith('pagamento-personalizado-')) {
      const creditoId = (item.id as string).replace('pagamento-personalizado-', '');
      const credito = creditosFinanceiros.find((c) => c.id === creditoId);
      setCreditoPagamentoPersonalizado(credito);
      setModalPagamentoPersonalizadoAberto(true);
    } else if (item.id === 'pagamento-personalizado') {
      setCreditoPagamentoPersonalizado(undefined);
      setModalPagamentoPersonalizadoAberto(true);
    } else if (item.id === 'cashback') {
      setModalCashbackAberto(true);
    } else if (abaSelecionada === 'produtos') {
      handleAbrirResgateProduto(item);
    } else if (abaSelecionada === 'vouchers') {
      handleAbrirResgateVoucher(item);
    } else if (abaSelecionada === 'experiencias') {
      handleAbrirResgateGenerico(item, 'experiencia');
    } else if (abaSelecionada === 'cursos') {
      handleAbrirResgateGenerico(item, 'curso');
    }
  };

  const getStatusBadge = (status: string) => {
    const statusConfig: Record<string, { cor: string; texto: string; icone: string }> = {
      entregue: { cor: 'bg-green-100 text-green-700', texto: 'Entregue', icone: 'ri-checkbox-circle-fill' },
      concluido: { cor: 'bg-green-100 text-green-700', texto: 'Concluído', icone: 'ri-checkbox-circle-fill' },
      em_transito: { cor: 'bg-blue-100 text-blue-700', texto: 'Em Trânsito', icone: 'ri-truck-line' },
      ativo: { cor: 'bg-purple-100 text-purple-700', texto: 'Ativo', icone: 'ri-play-circle-fill' },
      utilizado: { cor: 'bg-slate-100 text-slate-700', texto: 'Utilizado', icone: 'ri-check-double-line' },
      pendente: { cor: 'bg-yellow-100 text-yellow-700', texto: 'Pendente', icone: 'ri-time-line' }
    };
    const config = statusConfig[status] || statusConfig.pendente;
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${config.cor}`}>
        <i className={config.icone}></i>
        {config.texto}
      </span>
    );
  };

  const getTipoIcone = (tipo: string) => {
    const icones: Record<string, string> = {
      produto: 'ri-shopping-bag-line',
      financeiro: 'ri-bank-card-line',
      voucher: 'ri-coupon-line',
      curso: 'ri-graduation-cap-line',
      experiencia: 'ri-compass-3-line'
    };
    return icones[tipo] || 'ri-gift-line';
  };

  const recompensasAtuais = getRecompensasAtuais();

  const freteOpcoes = {
    normal: {
      label: 'Entrega Normal',
      prazo: '7 a 12 dias úteis',
      transportadora: 'Correios PAC',
      pontos: 0,
      icone: 'ri-truck-line'
    },
    expresso: {
      label: 'Entrega Expressa',
      prazo: '2 a 4 dias úteis',
      transportadora: 'Correios SEDEX',
      pontos: 500,
      icone: 'ri-flashlight-line'
    }
  };

  const gerarCodigoRastreio = () => {
    const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const nums = Math.floor(Math.random() * 900000000 + 100000000);
    const l1 = letras[Math.floor(Math.random() * letras.length)];
    const l2 = letras[Math.floor(Math.random() * letras.length)];
    return `${l1}${l2}${nums}BR`;
  };

  // Countdown para reenvio de token
  useEffect(() => {
    if (reenvioCountdownProduto > 0) {
      const t = setTimeout(() => setReenvioCountdownProduto(c => c - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [reenvioCountdownProduto]);

  useEffect(() => {
    if (reenvioCountdownVoucher > 0) {
      const t = setTimeout(() => setReenvioCountdownVoucher(c => c - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [reenvioCountdownVoucher]);

  useEffect(() => {
    if (reenvioCountdownGenerico > 0) {
      const t = setTimeout(() => setReenvioCountdownGenerico(c => c - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [reenvioCountdownGenerico]);

  const handleAbrirResgateGenerico = (item: any, tipo: 'experiencia' | 'curso') => {
    if (pontosDisponiveis < item.pontos) return;
    setItemGenericoSelecionado(item);
    setTipoItemGenerico(tipo);
    setEtapaGenerico('credito');
    setCreditoSelecionadoGenerico('');
    setTokenGenerico('');
    setTokenGenericoErro('');
    setReenvioCountdownGenerico(0);
    setModalResgateGenerico(true);
  };

  const handleFecharModalGenerico = () => {
    setModalResgateGenerico(false);
    setItemGenericoSelecionado(null);
    setEtapaGenerico('credito');
    setCreditoSelecionadoGenerico('');
    setTokenGenerico('');
    setTokenGenericoErro('');
    setReenvioCountdownGenerico(0);
  };

  const handleConfirmarCreditoGenerico = () => {
    if (!creditoSelecionadoGenerico) return;
    setTokenGenerico('');
    setTokenGenericoErro('');
    setReenvioCountdownGenerico(60);
    setEtapaGenerico('token');
  };

  const handleValidarTokenGenerico = () => {
    if (tokenGenerico.length !== 6) {
      setTokenGenericoErro('Digite o código de 6 dígitos enviado.');
      return;
    }
    const novoResgate = {
      id: `gen-${Date.now()}`,
      item: itemGenericoSelecionado.nome,
      tipo: tipoItemGenerico,
      pontos: itemGenericoSelecionado.pontos,
      data: new Date().toISOString().split('T')[0],
      status: tipoItemGenerico === 'curso' ? 'ativo' : 'concluido',
      acesso: tipoItemGenerico === 'curso' ? 'https://plataforma.com/curso' : undefined,
      validade: tipoItemGenerico === 'curso' ? new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0] : undefined,
      local: tipoItemGenerico === 'experiencia' ? 'A confirmar com o parceiro' : undefined,
    };
    setResgatesDinamicos(prev => [novoResgate, ...prev]);
    setTokenGenericoErro('');
    setEtapaGenerico('sucesso');
  };

  return (
    <div className="space-y-6">
      {/* Tour Virtual Overlay */}
      {tourAtivo && stepAtual && (
        <>
          {/* Overlay escuro */}
          <div className="fixed inset-0 bg-black/60 z-[9998]" onClick={finalizarTour}></div>

          {/* Destaque do elemento */}
          <div className="fixed inset-0 z-[9999] pointer-events-none">
            {(() => {
              const elemento = document.querySelector(stepAtual.target);
              if (!elemento) return null;

              const rect = elemento.getBoundingClientRect();
              const scrollY = window.scrollY || window.pageYOffset;
              const scrollX = window.scrollX || window.pageXOffset;
              
              return (
                <>
                  {/* Destaque com borda animada */}
                  <div
                    className="absolute border-4 border-orange-500 rounded-xl shadow-2xl pointer-events-auto animate-pulse"
                    style={{
                      top: `${rect.top + scrollY - 8}px`,
                      left: `${rect.left + scrollX - 8}px`,
                      width: `${rect.width + 16}px`,
                      height: `${rect.height + 16}px`,
                      boxShadow: '0 0 0 4px rgba(249, 115, 22, 0.3), 0 0 40px rgba(249, 115, 22, 0.5)'
                    }}
                  ></div>

                  {/* Tooltip com instruções */}
                  <div
                    className="absolute bg-white rounded-xl shadow-2xl p-6 pointer-events-auto max-w-sm animate-[slideIn_0.3s_ease-out]"
                    style={{
                      top: stepAtual.position === 'bottom' ? `${rect.bottom + scrollY + 20}px` : 
                           stepAtual.position === 'top' ? `${rect.top + scrollY - 200}px` : 
                           `${rect.top + scrollY}px`,
                      left: `${rect.left + scrollX}px`,
                      minWidth: '320px'
                    }}
                  >
                    {/* Header */}
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-slate-900 mb-1">{stepAtual.title}</h3>
                        <p className="text-sm text-slate-600">{stepAtual.description}</p>
                      </div>
                      <button
                        onClick={finalizarTour}
                        className="ml-4 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
                      >
                        <i className="ri-close-line text-xl text-slate-400"></i>
                      </button>
                    </div>

                    {/* Barra de progresso */}
                    <div className="mb-4">
                      <div className="flex items-center justify-between text-xs text-slate-500 mb-2">
                        <span>Progresso</span>
                        <span>{passoAtual + 1} de {tourSteps.length}</span>
                      </div>
                      <div className="h-2 bg-slate-200 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-orange-500 to-orange-600 transition-all duration-300"
                          style={{ width: `${((passoAtual + 1) / tourSteps.length) * 100}%` }}
                        ></div>
                      </div>
                    </div>

                    {/* Botões de navegação */}
                    <div className="flex items-center gap-3">
                      {passoAtual > 0 && (
                        <button
                          onClick={passoAnterior}
                          className="flex-1 px-4 py-2.5 bg-slate-100 text-slate-700 rounded-lg font-medium hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          <i className="ri-arrow-left-line mr-2"></i>
                          Anterior
                        </button>
                      )}
                      <button
                        onClick={proximoPasso}
                        className="flex-1 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-medium hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                      >
                        {passoAtual < tourSteps.length - 1 ? (
                          <>
                            Próximo
                            <i className="ri-arrow-right-line ml-2"></i>
                          </>
                        ) : (
                          <>
                            Finalizar
                            <i className="ri-check-line ml-2"></i>
                          </>
                        )}
                      </button>
                    </div>

                    {/* Seta apontando para o elemento */}
                    {stepAtual.position === 'bottom' && (
                      <div className="absolute -top-3 left-8 w-6 h-6 bg-white transform rotate-45 shadow-lg"></div>
                    )}
                    {stepAtual.position === 'top' && (
                      <div className="absolute -bottom-3 left-8 w-6 h-6 bg-white transform rotate-45 shadow-lg"></div>
                    )}
                  </div>
                </>
              );
            })()}
          </div>
        </>
      )}

      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">Catálogo de Recompensas</h1>
        <p className="text-slate-600">
          Resgate seus pontos por produtos, serviços e experiências incríveis
        </p>
      </div>

      {/* Card de Saldo */}
      <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-orange-100 text-sm mb-1">
              {campanhaAtual ? `Pontos — ${campanhaAtual.nome}` : 'Seus Pontos Disponíveis'}
            </p>
            <p className="text-4xl font-bold">{pontosDisponiveis.toLocaleString('pt-BR')}</p>
          </div>
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-coin-line text-3xl"></i>
          </div>
        </div>
      </div>

      {/* Abas de Categorias */}
      <div className="flex flex-wrap gap-2 bg-slate-100 p-1.5 rounded-xl">
        {abas.map((aba) => (
          <button
            key={aba.id}
            onClick={() => setAbaSelecionada(aba.id)}
            data-tour={aba.id === 'financeira' ? 'aba-financeira' : undefined}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
              abaSelecionada === aba.id
                ? 'bg-white text-orange-600 shadow-sm'
                : 'text-slate-600 hover:text-slate-900 hover:bg-white/50'
            }`}
          >
            <i className={aba.icone}></i>
            {aba.nome}
          </button>
        ))}
      </div>

      {/* Informações Importantes */}
      {infoCardVisivel && (
        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-200 relative">
          <button
            onClick={() => setInfoCardVisivel(false)}
            className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-600 hover:bg-blue-100 transition-colors cursor-pointer"
            title="Fechar"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-xl bg-blue-500 flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="font-semibold text-slate-900 mb-2">Informações sobre Resgates</h3>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-0.5"></i>
                  <span>Os resgates são processados em até 2 horas</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-0.5"></i>
                  <span>Você receberá uma notificação quando o resgate for concluído</span>
                </li>

                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-0.5"></i>
                  <span>Consulte o extrato para acompanhar seus resgates</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-0.5"></i>
                  <span className="text-emerald-700 font-medium">Os valores em pontos podem variar conforme a recompensa escolhida.</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill text-emerald-600 mt-0.5"></i>
                  <span className="text-emerald-700 font-medium">Resgates financeiros devem obrigatoriamente ocorrer a favor do próprio beneficiário do prêmio.</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-error-warning-fill text-red-500 mt-0.5"></i>
                  <span className="text-red-600 font-medium">Pontos não resgatados dentro do prazo perderão sua validade e serão devolvidos à patrocinadora da campanha.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Conteúdo da Aba Selecionada */}
      {abaSelecionada !== 'resgates' ? (
        <div>
          {/* Aba Financeira — 2 cards: unificado PIX+Pagamento e CashBack */}
          {abaSelecionada === 'financeira' && (
            <>
              {/* Aviso sobre prêmios financeiros */}
              <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 mb-2">
                <span className="text-lg leading-none mt-0.5 flex-shrink-0">💡</span>
                <p className="text-sm text-amber-800">
                  <strong>Atenção:</strong> Prêmios financeiros costumam ser menos vantajosos que outras opções. Considere explorar vouchers, produtos ou experiências para aproveitar melhor seus pontos.
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <PixPagamentoCard
                  dataTourCard="card-pix"
                  dataTourBtn="btn-resgatar-pix"
                  onResgatar={(tipo, creditoId) => {
                    const credito = creditosFinanceiros.find(c => c.id === creditoId);
                    if (tipo === 'pix') {
                      setCreditoPixPersonalizado(credito);
                      setModalPixPersonalizadoAberto(true);
                    } else {
                      setCreditoPagamentoPersonalizado(credito);
                      setModalPagamentoPersonalizadoAberto(true);
                    }
                  }}
                />
                <FinancialCard
                  tipo="cashback"
                  imagem="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/9efecf4d720f800189f4073a3af54c3a.png"
                  onResgatar={() => setModalCashbackAberto(true)}
                />
              </div>
            </>
          )}

          {/* Busca e Categorias — apenas na aba Produtos */}
          {abaSelecionada === 'produtos' && (
            <div className="mb-6 space-y-4">
              {/* Barra de busca */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <i className="ri-search-line text-slate-400 text-lg"></i>
                </div>
                <input
                  type="text"
                  value={buscaProduto}
                  onChange={(e) => setBuscaProduto(e.target.value)}
                  placeholder="Buscar produtos por nome, descrição ou categoria..."
                  className="w-full pl-11 pr-10 py-3 bg-white border border-slate-200 rounded-xl text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all"
                />
                {buscaProduto && (
                  <button
                    onClick={() => setBuscaProduto('')}
                    className="absolute inset-y-0 right-0 pr-4 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
                  >
                    <i className="ri-close-circle-line text-lg"></i>
                  </button>
                )}
              </div>

              {/* Filtros de categoria */}
              <div className="flex flex-wrap gap-2">
                {categoriasProdutos.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => setCategoriaProduto(cat.id)}
                    className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      categoriaProduto === cat.id
                        ? 'bg-orange-500 text-white shadow-sm'
                        : 'bg-white border border-slate-200 text-slate-600 hover:border-orange-300 hover:text-orange-600'
                    }`}
                  >
                    <i className={cat.icone}></i>
                    {cat.nome}
                  </button>
                ))}
              </div>

              {/* Contador de resultados */}
              <div className="flex items-center justify-between">
                <p className="text-sm text-slate-500">
                  {produtosFiltrados.length === 0
                    ? 'Nenhum produto encontrado'
                    : `${produtosFiltrados.length} produto${produtosFiltrados.length !== 1 ? 's' : ''} encontrado${produtosFiltrados.length !== 1 ? 's' : ''}`}
                </p>
                {(buscaProduto || categoriaProduto !== 'todos') && (
                  <button
                    onClick={() => { setBuscaProduto(''); setCategoriaProduto('todos'); }}
                    className="text-sm text-orange-500 hover:text-orange-700 font-medium cursor-pointer transition-colors"
                  >
                    Limpar filtros
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Busca e Categorias — aba Vouchers */}
          {abaSelecionada === 'vouchers' && (
            <div className="mb-6 space-y-4">
              {/* Barra de busca */}
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <i className="ri-search-line text-slate-400 text-lg"></i>
                </div>
                <input
                  type="text"
                  value={buscaVoucher}
                  onChange={(e) => setBuscaVoucher(e.target.value)}
                  placeholder="Buscar vouchers por nome, descrição ou categoria..."
                  className="w-full pl-11 pr-10 py-3 bg-white border border-slate-200 rounded-xl text-sm text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all"
                />
                {buscaVoucher && (
                  <button
                    onClick={() => setBuscaVoucher('')}
                    className="absolute inset-y-0 right-0 pr-4 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
                  >
                    <i className="ri-close-circle-line text-lg"></i>
                  </button>
                )}
              </div>

              {/* Filtros de categoria */}
              <div className="flex flex-wrap gap-2">
                {categoriasVouchers.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => setCategoriaVoucher(cat.id)}
                    className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      categoriaVoucher === cat.id
                        ? 'bg-orange-500 text-white shadow-sm'
                        : 'bg-white border border-slate-200 text-slate-600 hover:border-orange-300 hover:text-orange-600'
                    }`}
                  >
                    <i className={cat.icone}></i>
                    {cat.nome}
                  </button>
                ))}
              </div>

              {/* Contador de resultados */}
              <div className="flex items-center justify-between">
                <p className="text-sm text-slate-500">
                  {vouchersFiltrados.length === 0
                    ? 'Nenhum voucher encontrado'
                    : `${vouchersFiltrados.length} voucher${vouchersFiltrados.length !== 1 ? 's' : ''} encontrado${vouchersFiltrados.length !== 1 ? 's' : ''}`}
                </p>
                {(buscaVoucher || categoriaVoucher !== 'todos') && (
                  <button
                    onClick={() => { setBuscaVoucher(''); setCategoriaVoucher('todos'); }}
                    className="text-sm text-orange-500 hover:text-orange-700 font-medium cursor-pointer transition-colors"
                  >
                    Limpar filtros
                  </button>
                )}
              </div>
            </div>
          )}

          {abaSelecionada !== 'financeira' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {getRecompensasAtuais().length === 0 && abaSelecionada === 'produtos' ? (
              <div className="col-span-3 flex flex-col items-center justify-center py-16 text-center">
                <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-search-line text-2xl text-slate-400"></i>
                </div>
                <p className="text-slate-600 font-medium mb-1">Nenhum produto encontrado</p>
                <p className="text-slate-400 text-sm">Tente outros termos ou remova os filtros</p>
              </div>
            ) : getRecompensasAtuais().length === 0 && abaSelecionada === 'vouchers' ? (
              <div className="col-span-3 flex flex-col items-center justify-center py-16 text-center">
                <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-search-line text-2xl text-slate-400"></i>
                </div>
                <p className="text-slate-600 font-medium mb-1">Nenhum voucher encontrado</p>
                <p className="text-slate-400 text-sm">Tente outros termos ou remova os filtros</p>
              </div>
            ) : (
              getRecompensasAtuais().map((item) => {
                // Verifica se é card de crédito personalizado e calcula dias para expiração
                const isCreditoPersonalizado = (item.id as string)?.startsWith('pix-personalizado-') || (item.id as string)?.startsWith('pagamento-personalizado-');
                let diasParaExpirar: number | null = null;
                let expirado = false;
                let urgente = false;
                let muitoUrgente = false;

                if (isCreditoPersonalizado) {
                  const creditoId = (item.id as string).replace('pix-personalizado-', '').replace('pagamento-personalizado-', '');
                  const credito = creditosFinanceiros.find((c) => c.id === creditoId);
                  if (credito) {
                    const dataCredito = new Date(credito.dataCredito);
                    const dataExpiracao = new Date(dataCredito);
                    const diasExp = Math.min(credito.diasExpiracao, 360);
                    dataExpiracao.setDate(dataExpiracao.getDate() + diasExp);
                    const hoje = new Date();
                    const diffMs = dataExpiracao.getTime() - hoje.getTime();
                    diasParaExpirar = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                    expirado = diasParaExpirar <= 0;
                    urgente = diasParaExpirar > 0 && diasParaExpirar <= 60;
                    muitoUrgente = diasParaExpirar > 0 && diasParaExpirar <= 30;
                  }
                }

                return (
                <div
                  key={item.id}
                  data-tour={item.id === 'pix' ? 'card-pix' : item.id === 'pagamento-contas' ? 'card-pagamento' : undefined}
                  className={`bg-white rounded-xl overflow-hidden border hover:shadow-xl transition-all hover:-translate-y-1 group ${
                    muitoUrgente
                      ? 'border-red-400 ring-2 ring-red-400 animate-pulse'
                      : urgente
                      ? 'border-amber-400 ring-2 ring-amber-400'
                      : 'border-slate-200'
                  }`}
                >
                  {/* Imagem */}
                  <div className="relative h-48 overflow-hidden bg-slate-100">
                    <img
                      src={item.imagem}
                      alt={item.nome}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    {item.destaque && (
                      <div className="absolute top-3 left-3 px-3 py-1 bg-orange-500 text-white text-xs font-bold rounded-full">
                        ⭐ Destaque
                      </div>
                    )}
                  </div>

                  {/* Conteúdo */}
                  <div className="p-5">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-slate-900 mb-1">{item.nome}</h3>
                        <p className="text-sm text-slate-600 line-clamp-2">{item.descricao}</p>
                      </div>
                    </div>

                    {/* Tags */}
                    {item.tags && item.tags.length > 0 && (
                      <div className="flex flex-wrap gap-2 mb-4">
                        {item.tags.map((tag: string, index: number) => (
                          <span
                            key={index}
                            className="px-2 py-1 bg-slate-100 text-slate-700 text-xs font-medium rounded-full"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    )}

                    {/* Valor — lógica diferenciada para financeiro */}
                    <div className="flex items-center justify-between mb-4 pb-4 border-b border-slate-100">
                      {abaSelecionada === 'financeira' && (item.id === 'pix' || item.id === 'pagamento-contas') ? (
                        <div className="w-full">
                          <p className="text-sm text-slate-500 mb-1">Exemplo de resgate</p>
                          <div className="flex items-end gap-2">
                            <div>
                              <p className="text-base text-slate-700 font-medium">
                                {item.id === 'pix'
                                  ? `Receber R$ ${(item as any).exemploValor?.toLocaleString('pt-BR') ?? '100'} via PIX`
                                  : `Pagar conta de R$ ${(item as any).exemploValor?.toLocaleString('pt-BR') ?? '200'}`}
                              </p>
                              <p className="text-3xl font-bold text-orange-600">
                                {calcularPontosFinanceiro((item as any).exemploValor ?? 100).toLocaleString('pt-BR')}
                                <span className="text-base text-slate-500 ml-1">pts</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : abaSelecionada === 'financeira' && (item as any).personalizado ? (
                        <div className="w-full">
                          <p className="text-sm text-slate-500 mb-1">{(item as any).creditoNome}</p>
                          <div className="flex items-end gap-2">
                            <div>
                              <p className="text-base text-slate-700 font-medium">
                                {(item as any).id?.startsWith('pix-personalizado')
                                  ? `Receber R$ ${(item as any).creditoValor?.toLocaleString('pt-BR')} via PIX`
                                  : `Pagar conta de R$ ${(item as any).creditoValor?.toLocaleString('pt-BR')}`}
                              </p>
                              <p className="text-3xl font-bold text-orange-600">
                                {calcularPontosFinanceiro((item as any).creditoValor ?? 0).toLocaleString('pt-BR')}
                                <span className="text-base text-slate-500 ml-1">pts</span>
                              </p>
                            </div>
                          </div>
                          {/* Data de crédito e expiração para cards personalizados */}
                          {(() => {
                            const creditoId = (item.id as string).replace('pix-personalizado-', '').replace('pagamento-personalizado-', '');
                            const credito = creditosFinanceiros.find((c) => c.id === creditoId);
                            if (!credito) return null;
                            const dataCredito = new Date(credito.dataCredito);
                            const dataExpiracao = new Date(dataCredito);
                            const diasExp = Math.min(credito.diasExpiracao, 360);
                            dataExpiracao.setDate(dataExpiracao.getDate() + diasExp);
                            const hoje = new Date();
                            const diffMs = dataExpiracao.getTime() - hoje.getTime();
                            const diasRestantes = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
                            const expirado = diasRestantes <= 0;
                            const urgente = diasRestantes > 0 && diasRestantes <= 60; // Alterado para 60 dias
                            const muitoUrgente = diasRestantes > 0 && diasRestantes <= 30;
                            return (
                              <div className="mt-3 pt-3 border-t border-slate-100 space-y-2">
                                <div className="flex items-center gap-2 text-base text-slate-600">
                                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                                    <i className="ri-calendar-check-line text-slate-500 text-lg"></i>
                                  </div>
                                  <span>
                                    Creditado em <strong className="text-slate-800">{dataCredito.toLocaleDateString('pt-BR')}</strong>
                                  </span>
                                  <button
                                    onClick={() => {
                                      const dataStr = dataCredito.toLocaleDateString('pt-BR');
                                      navigate(`/premiado/extrato?busca=${encodeURIComponent(dataStr)}&tipo=bonus`);
                                    }}
                                    className="ml-1 inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-teal-50 text-teal-700 text-xs font-semibold hover:bg-teal-100 transition-colors cursor-pointer whitespace-nowrap border border-teal-200"
                                    title="Ver no extrato"
                                  >
                                    <i className="ri-external-link-line text-sm"></i>
                                    Ver no extrato
                                  </button>
                                </div>
                                <div className={`flex items-center gap-2 text-base font-medium ${expirado ? 'text-red-600' : muitoUrgente ? 'text-red-600' : urgente ? 'text-amber-600' : 'text-slate-600'}`}>
                                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                                    <i className={`text-lg ${expirado || muitoUrgente ? 'ri-time-line text-red-500' : urgente ? 'ri-alarm-warning-line text-amber-500' : 'ri-timer-line text-slate-500'}`}></i>
                                  </div>
                                  {expirado
                                    ? <span className="text-red-600 font-semibold">Crédito expirado</span>
                                    : <span>Expira em <strong>{diasRestantes} dia{diasRestantes !== 1 ? 's' : ''}</strong> ({dataExpiracao.toLocaleDateString('pt-BR')})</span>
                                  }
                                </div>
                                {/* Badge de alerta para expiração próxima */}
                                {urgente && !expirado && (
                                  <div className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold ${muitoUrgente ? 'bg-red-100 text-red-700 border border-red-200 animate-pulse' : 'bg-amber-100 text-amber-700 border border-amber-200'}`}>
                                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                                      <i className={`text-lg ${muitoUrgente ? 'ri-alarm-warning-fill' : 'ri-error-warning-fill'}`}></i>
                                    </div>
                                    <span>
                                      {muitoUrgente
                                        ? `⚠️ Atenção! Menos de 30 dias para expirar`
                                        : `⏰ Expira em menos de 60 dias - Resgate já!`}
                                    </span>
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </div>
                      ) : (
                        <div className="w-full">
                          <p className="text-xs text-slate-500 mb-1">
                            {abaSelecionada === 'financeira' ? 'Valor Disponível' : 'Pontos Necessários'}
                          </p>
                          {abaSelecionada === 'financeira' && (
                            <p className="text-sm text-slate-700 font-medium">Em breve disponível</p>
                          )}
                          <p className="text-2xl font-bold text-orange-600">
                            {abaSelecionada === 'financeira'
                              ? pontosDisponiveis.toLocaleString('pt-BR')
                              : item.pontos.toLocaleString('pt-BR')
                            }
                            <span className="text-sm text-slate-500 ml-1">pts</span>
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Botão de Resgate */}
                    <button
                      onClick={() => handleResgatar(item)}
                      disabled={!item.disponivel || (abaSelecionada !== 'financeira' && pontosDisponiveis < item.pontos)}
                      data-tour={item.id === 'pix' ? 'btn-resgatar-pix' : item.id === 'pagamento-contas' ? 'btn-resgatar-pagamento' : undefined}
                      className={`w-full py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                        item.disponivel && (abaSelecionada === 'financeira' || pontosDisponiveis >= item.pontos)
                          ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white hover:shadow-lg hover:from-orange-600 hover:to-orange-700'
                          : 'bg-slate-200 text-slate-400 cursor-not-allowed'
                      }`}
                    >
                      {item.disponivel && (abaSelecionada === 'financeira' || pontosDisponiveis >= item.pontos) ? (
                        <>
                          <i className="ri-gift-line mr-2"></i>
                          Resgatar Agora
                        </>
                      ) : (
                        <>
                          <i className="ri-lock-line mr-2"></i>
                          {!item.disponivel ? 'Indisponível' : 'Pontos Insuficientes'}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              );
              })
            )}
          </div>
          )}
        </div>
      ) : (
        /* Seção Meus Resgates */
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-bold text-slate-900">Histórico de Resgates</h2>
          </div>
          <MeusResgates resgates={historicoResgates} />
        </div>
      )}

      {/* Modais */}
      <PixModal
        isOpen={modalPixAberto}
        onClose={() => setModalPixAberto(false)}
        saldoDisponivel={pontosDisponiveis}
      />

      <PagamentoContaModal
        isOpen={modalPagamentoAberto}
        onClose={() => setModalPagamentoAberto(false)}
        pontosDisponiveis={pontosDisponiveis}
      />

      <PixPersonalizadoModal
        isOpen={modalPixPersonalizadoAberto}
        onClose={() => setModalPixPersonalizadoAberto(false)}
        pontosDisponiveis={pontosDisponiveis}
        creditoPreSelecionado={creditoPixPersonalizado}
      />

      <PagamentoPersonalizadoModal
        isOpen={modalPagamentoPersonalizadoAberto}
        onClose={() => setModalPagamentoPersonalizadoAberto(false)}
        pontosDisponiveis={pontosDisponiveis}
        creditoPreSelecionado={creditoPagamentoPersonalizado}
      />

      {/* Modal de Resgate de Produto */}
      {modalResgateProduto && produtoSelecionado && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-lg w-full overflow-hidden shadow-2xl animate-[scaleIn_0.3s_ease-out]">

            {/* Header */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-gift-line text-white text-xl"></i>
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">Resgatar Produto</h2>
                  <p className="text-orange-100 text-xs">
                    {(() => {
                      const temValores = !!produtoSelecionado.valores;
                      const total = temValores ? 4 : 3;
                      if (etapaResgate === 'endereco') return `Passo 1 de ${total} — Endereço de entrega`;
                      if (etapaResgate === 'confirmacao') return `Passo ${temValores ? 2 : 1} de ${total} — Confirmar pedido`;
                      if (etapaResgate === 'token') return `Passo ${temValores ? 3 : 2} de ${total} — Verificação de segurança`;
                      if (etapaResgate === 'sucesso') return 'Produto enviado com sucesso!';
                      return '';
                    })()}
                  </p>
                </div>
              </div>
              {etapaResgate !== 'sucesso' && (
                <button onClick={handleFecharModalResgate} className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-close-line text-white text-lg"></i>
                </button>
              )}
            </div>

            {/* Produto resumo */}
            {etapaResgate !== 'sucesso' && (
              <div className="flex items-center gap-4 px-6 py-4 bg-orange-50 border-b border-orange-100">
                <img src={produtoSelecionado.imagem} alt={produtoSelecionado.nome} className="w-16 h-16 object-cover rounded-xl border border-orange-200" />
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-slate-900 truncate">{produtoSelecionado.nome}</p>
                  <p className="text-sm text-slate-500 truncate">{produtoSelecionado.descricao}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-lg font-bold text-slate-900">
                    {produtoSelecionado.pontos.toLocaleString('pt-BR')}
                  </p>
                  <p className="text-xs text-slate-500">pontos</p>
                </div>
              </div>
            )}

            {/* ETAPA 1: Endereço */}
            {etapaResgate === 'endereco' && (
              <div className="p-6 space-y-4 max-h-[60vh] overflow-y-auto">
                <h3 className="font-semibold text-slate-800 flex items-center gap-2">
                  <i className="ri-map-pin-line text-orange-500"></i>
                  Endereço de Entrega
                </h3>

                <div className="grid grid-cols-2 gap-3">
                  <div className="col-span-2">
                    <label className="block text-xs font-medium text-slate-600 mb-1">Nome do destinatário</label>
                    <input
                      type="text"
                      value={enderecoEntrega.nome}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, nome: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">CEP</label>
                    <input
                      type="text"
                      value={enderecoEntrega.cep}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, cep: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Estado</label>
                    <input
                      type="text"
                      value={enderecoEntrega.estado}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, estado: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-xs font-medium text-slate-600 mb-1">Logradouro</label>
                    <input
                      type="text"
                      value={enderecoEntrega.logradouro}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, logradouro: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Número</label>
                    <input
                      type="text"
                      value={enderecoEntrega.numero}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, numero: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Complemento</label>
                    <input
                      type="text"
                      value={enderecoEntrega.complemento}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, complemento: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Bairro</label>
                    <input
                      type="text"
                      value={enderecoEntrega.bairro}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, bairro: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1">Cidade</label>
                    <input
                      type="text"
                      value={enderecoEntrega.cidade}
                      onChange={e => setEnderecoEntrega(prev => ({ ...prev, cidade: e.target.value }))}
                      className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                    />
                  </div>
                </div>

                {/* Opções de frete */}
                <div>
                  <h4 className="font-semibold text-slate-800 mb-3 flex items-center gap-2">
                    <i className="ri-truck-line text-orange-500"></i>
                    Modalidade de Entrega
                  </h4>
                  <div className="space-y-2">
                    {(Object.entries(freteOpcoes) as [string, typeof freteOpcoes.normal][]).map(([key, opcao]) => (
                      <label
                        key={key}
                        className={`flex items-center gap-4 p-3 rounded-xl border-2 cursor-pointer transition-all ${
                          freteOpcao === key
                            ? 'border-orange-400 bg-orange-50'
                            : 'border-slate-200 hover:border-orange-200'
                        }`}
                      >
                        <input
                          type="radio"
                          name="frete"
                          value={key}
                          checked={freteOpcao === key}
                          onChange={() => setFreteOpcao(key as 'normal' | 'expresso')}
                          className="accent-orange-500"
                        />
                        <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-orange-100">
                          <i className={`${opcao.icone} text-orange-600`}></i>
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-slate-800">{opcao.label}</p>
                          <p className="text-xs text-slate-500">{opcao.transportadora} • Prazo: {opcao.prazo}</p>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>

                <button
                  onClick={handleConfirmarEndereco}
                  className="w-full py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  Continuar
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            )}

            {/* ETAPA 2: Confirmação */}
            {etapaResgate === 'confirmacao' && (
              <div className="p-6 space-y-4">
                <h3 className="font-semibold text-slate-800 flex items-center gap-2">
                  <i className="ri-file-list-3-line text-orange-500"></i>
                  Resumo do Pedido
                </h3>

                {/* Seletor de Crédito */}
                {(() => {
                  const pontosNecessariosProduto = produtoSelecionado.pontos + freteOpcoes[freteOpcao].pontos;
                  const creditoAtualProduto = creditosFinanceiros.find(x => x.id === creditoSelecionadoProduto);
                  const pontosCreditoProduto = creditoAtualProduto ? calcularPontosFinanceiro(creditoAtualProduto.valor) : 0;
                  const creditosSuficientes = creditosFinanceiros.filter(c => calcularPontosFinanceiro(c.valor) >= pontosNecessariosProduto);
                  return (
                    <div className="space-y-2">
                      <label className="block text-xs font-semibold text-slate-700">
                        <i className="ri-coin-line text-orange-500 mr-1"></i>
                        Crédito para desconto dos pontos
                      </label>
                      {creditosSuficientes.length === 0 ? (
                        <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                          <i className="ri-error-warning-fill text-red-500 text-lg mt-0.5 flex-shrink-0"></i>
                          <div>
                            <p className="text-sm font-semibold text-red-700">Nenhum crédito disponível</p>
                            <p className="text-xs text-red-600 mt-0.5">
                              Nenhum dos seus créditos possui saldo suficiente para este resgate. Necessário: <strong>{pontosNecessariosProduto.toLocaleString('pt-BR')} pts</strong>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-1.5">
                          {creditosSuficientes.map(c => {
                            const pontosCredito = calcularPontosFinanceiro(c.valor);
                            const selecionado = creditoSelecionadoProduto === c.id;
                            return (
                              <button
                                key={c.id}
                                type="button"
                                onClick={() => setCreditoSelecionadoProduto(c.id)}
                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border-2 transition-all text-left cursor-pointer ${
                                  selecionado
                                    ? 'border-orange-500 bg-orange-50'
                                    : 'border-slate-200 hover:border-orange-300 hover:bg-orange-50/40'
                                }`}
                              >
                                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ${selecionado ? 'bg-orange-500' : 'bg-orange-100'}`}>
                                  {selecionado
                                    ? <i className="ri-check-line text-white text-sm"></i>
                                    : <i className="ri-medal-line text-orange-500 text-sm"></i>
                                  }
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm font-semibold truncate text-slate-800">{c.descricao}</p>
                                  <p className="text-xs truncate text-slate-500">{c.campanha}</p>
                                </div>
                                <div className="text-right flex-shrink-0">
                                  <p className="text-sm font-bold text-orange-600">{pontosCredito.toLocaleString('pt-BR')} pts</p>
                                  <p className="text-xs text-emerald-600">Saldo suficiente</p>
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      )}
                      {creditoSelecionadoProduto && creditoAtualProduto && (
                        <div className="bg-green-50 border border-green-200 rounded-xl px-3 py-2 flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill text-green-500"></i>
                            <span className="text-xs text-green-700 font-medium">Crédito selecionado</span>
                          </div>
                          <span className="text-xs text-green-700">
                            Saldo restante: <strong>{(pontosCreditoProduto - pontosNecessariosProduto).toLocaleString('pt-BR')} pts</strong>
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* Endereço */}
                <div className="bg-slate-50 rounded-xl p-4 space-y-1">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Endereço de Entrega</p>
                  <p className="text-sm font-semibold text-slate-800">{enderecoEntrega.nome}</p>
                  <p className="text-sm text-slate-600">{enderecoEntrega.logradouro}, {enderecoEntrega.numero} {enderecoEntrega.complemento && `- ${enderecoEntrega.complemento}`}</p>
                  <p className="text-sm text-slate-600">{enderecoEntrega.bairro} — {enderecoEntrega.cidade}/{enderecoEntrega.estado}</p>
                  <p className="text-sm text-slate-600">CEP: {enderecoEntrega.cep}</p>
                </div>

                {/* Frete */}
                <div className="bg-slate-50 rounded-xl p-4">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Entrega</p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-orange-100">
                      <i className={`${freteOpcoes[freteOpcao].icone} text-orange-600`}></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-slate-800">{freteOpcoes[freteOpcao].label}</p>
                      <p className="text-xs text-slate-500">{freteOpcoes[freteOpcao].transportadora} • Prazo: {freteOpcoes[freteOpcao].prazo}</p>
                    </div>
                  </div>
                </div>

                {/* Pontos */}
                <div className="bg-orange-50 rounded-xl p-4 border border-orange-200">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Resumo de Pontos</p>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-slate-600">Produto</span>
                      <span className="font-semibold text-slate-800">{produtoSelecionado.pontos.toLocaleString('pt-BR')} pts</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-slate-600">Frete ({freteOpcoes[freteOpcao].label})</span>
                      <span className={`font-semibold ${freteOpcoes[freteOpcao].pontos === 0 ? 'text-green-600' : 'text-orange-600'}`}>
                        {freteOpcoes[freteOpcao].pontos === 0 ? 'Grátis' : `+${freteOpcoes[freteOpcao].pontos.toLocaleString('pt-BR')} pts`}
                      </span>
                    </div>
                    <div className="border-t border-orange-200 pt-2 flex justify-between font-bold text-base">
                      <span className="text-slate-800">Total</span>
                      <span className="text-orange-600">
                        {(produtoSelecionado.pontos + freteOpcoes[freteOpcao].pontos).toLocaleString('pt-BR')} pts
                      </span>
                    </div>
                  </div>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => setEtapaResgate('endereco')}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-2"></i>
                    Voltar
                  </button>
                  <button
                    onClick={handleConfirmarResgate}
                    disabled={!creditoSelecionadoProduto || (() => {
                      const c = creditosFinanceiros.find(x => x.id === creditoSelecionadoProduto);
                      if (!c) return true;
                      return calcularPontosFinanceiro(c.valor) < (produtoSelecionado.pontos + freteOpcoes[freteOpcao].pontos);
                    })()}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <i className="ri-shield-check-line mr-2"></i>
                    Confirmar e Verificar
                  </button>
                </div>
              </div>
            )}

            {/* ETAPA TOKEN: Verificação de Segurança — Produto */}
            {etapaResgate === 'token' && (
              <div className="p-6 space-y-5">
                {/* Ícone e título */}
                <div className="text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-shield-keyhole-line text-3xl text-orange-500"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-lg">Verificação de Segurança</h3>
                  <p className="text-sm text-slate-500 mt-1">
                    Enviamos um código de 6 dígitos para confirmar sua identidade.
                  </p>
                </div>

                {/* Canais de envio do token */}
                <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 space-y-2">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Código enviado para</p>
                  {contatoVoucher.canaisEnvio.email && (
                    <div className="flex items-center gap-2 text-sm text-slate-700">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-mail-check-line text-orange-500"></i>
                      </div>
                      <span>{contatoVoucher.email.replace(/(.{2})(.*)(@.*)/, '$1***$3')}</span>
                    </div>
                  )}
                  {contatoVoucher.canaisEnvio.whatsapp && (
                    <div className="flex items-center gap-2 text-sm text-slate-700">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-whatsapp-line text-green-500"></i>
                      </div>
                      <span>{contatoVoucher.whatsapp.replace(/(\(\d{2}\))\s?(\d{5})-?(\d{4})/, '$1 *****-$3')}</span>
                    </div>
                  )}
                </div>

                {/* Input do token */}
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-2">Código de verificação</label>
                  <input
                    type="text"
                    maxLength={6}
                    value={tokenProduto}
                    onChange={e => {
                      setTokenProduto(e.target.value.replace(/\D/g, '').slice(0, 6));
                      setTokenProdutoErro('');
                    }}
                    placeholder="000000"
                    className={`w-full px-4 py-3 border-2 rounded-xl text-center text-2xl font-bold tracking-[0.5em] focus:outline-none transition-all ${
                      tokenProdutoErro
                        ? 'border-red-400 bg-red-50 text-red-700'
                        : tokenProduto.length === 6
                        ? 'border-green-400 bg-green-50 text-green-700'
                        : 'border-slate-200 focus:border-orange-400'
                    }`}
                  />
                  {tokenProdutoErro && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                      <i className="ri-error-warning-line"></i>
                      {tokenProdutoErro}
                    </p>
                  )}
                </div>

                {/* Reenviar código */}
                <div className="text-center">
                  {reenvioCountdownProduto > 0 ? (
                    <p className="text-sm text-slate-400">
                      Reenviar código em <span className="font-semibold text-orange-500">{reenvioCountdownProduto}s</span>
                    </p>
                  ) : (
                    <button
                      onClick={handleReenviarTokenProduto}
                      className="text-sm text-orange-500 hover:text-orange-700 font-medium cursor-pointer transition-colors"
                    >
                      <i className="ri-refresh-line mr-1"></i>
                      Reenviar código
                    </button>
                  )}
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => setEtapaResgate('endereco')}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-2"></i>
                    Voltar
                  </button>
                  <button
                    onClick={handleValidarTokenProduto}
                    disabled={tokenProduto.length !== 6}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-check-line mr-2"></i>
                    Validar e Concluir
                  </button>
                </div>
              </div>
            )}

            {/* ETAPA 4: Sucesso */}
            {etapaResgate === 'sucesso' && (
              <div className="p-8 text-center space-y-5">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-checkbox-circle-fill text-5xl text-green-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-1">Resgate Confirmado! 🎉</h3>
                  <p className="text-slate-500 text-sm">Seu produto está a caminho!</p>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 text-left space-y-3">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Código do Voucher</p>
                  <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg px-3 py-2">
                    <i className="ri-coupon-line text-orange-500"></i>
                    <span className="font-mono text-sm font-bold text-slate-800 flex-1 tracking-widest">{codigoVoucherGerado}</span>
                    <button
                      onClick={() => navigator.clipboard?.writeText(codigoVoucherGerado)}
                      className="text-slate-400 hover:text-orange-500 transition-colors cursor-pointer"
                      title="Copiar código"
                    >
                      <i className="ri-file-copy-line"></i>
                    </button>
                  </div>

                  {/* Canais enviados */}
                  <div className="space-y-2">
                    <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Enviado via</p>
                    {contatoVoucher.canaisEnvio.email && (
                      <div className="flex items-center gap-2 text-sm text-slate-700">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <i className="ri-mail-check-line text-orange-500"></i>
                        </div>
                        <span>E-mail: <strong>{contatoVoucher.email}</strong></span>
                      </div>
                    )}
                    {contatoVoucher.canaisEnvio.whatsapp && (
                      <div className="flex items-center gap-2 text-sm text-slate-700">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <i className="ri-whatsapp-line text-green-500"></i>
                        </div>
                        <span>WhatsApp: <strong>{contatoVoucher.whatsapp}</strong></span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={handleFecharModalResgate}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Fechar
                  </button>
                  <button
                    onClick={handleVerMeusResgates}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-history-line mr-2"></i>
                    Ver Meus Resgates
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal de Resgate de Voucher */}
      {modalResgateVoucher && voucherSelecionado && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-lg w-full overflow-hidden shadow-2xl animate-[scaleIn_0.3s_ease-out]">

            {/* Header */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-coupon-line text-white text-xl"></i>
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">Resgatar Voucher</h2>
                  <p className="text-orange-100 text-xs">
                    {(() => {
                      const temValores = !!voucherSelecionado.valores;
                      const total = temValores ? 4 : 3;
                      if (etapaResgateVoucher === 'valor') return `Passo 1 de ${total} — Escolha o valor`;
                      if (etapaResgateVoucher === 'contato') return `Passo ${temValores ? 2 : 1} de ${total} — Como deseja receber?`;
                      if (etapaResgateVoucher === 'confirmacao') return `Passo ${temValores ? 3 : 2} de ${total} — Confirmar resgate`;
                      if (etapaResgateVoucher === 'token') return `Passo ${temValores ? 4 : 3} de ${total} — Verificação de segurança`;
                      if (etapaResgateVoucher === 'sucesso') return 'Voucher enviado com sucesso!';
                      return '';
                    })()}
                  </p>
                </div>
              </div>
              {etapaResgateVoucher !== 'sucesso' && (
                <button onClick={handleFecharModalVoucher} className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-close-line text-white text-lg"></i>
                </button>
              )}
            </div>

            {/* Voucher resumo */}
            {etapaResgateVoucher !== 'sucesso' && (
              <div className="flex items-center gap-4 px-6 py-4 bg-orange-50 border-b border-orange-100">
                <img src={voucherSelecionado.imagem} alt={voucherSelecionado.nome} className="w-16 h-16 object-cover rounded-xl border border-orange-200" />
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-slate-900 truncate">{voucherSelecionado.nome}</p>
                  <p className="text-sm text-slate-500 truncate">{voucherSelecionado.descricao}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-lg font-bold text-slate-900">
                    {(valorVoucherSelecionado ? valorVoucherSelecionado.pontos : voucherSelecionado.pontos).toLocaleString('pt-BR')}
                  </p>
                  <p className="text-xs text-slate-500">pontos</p>
                </div>
              </div>
            )}

            {/* ETAPA VALOR: Escolha o valor */}
            {etapaResgateVoucher === 'valor' && voucherSelecionado.valores && (
              <div className="p-6 space-y-5">
                <div className="flex items-start gap-3 bg-orange-50 border border-orange-200 rounded-xl p-4">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-price-tag-3-line text-orange-500 text-xl"></i>
                  </div>
                  <p className="text-sm text-orange-700">
                    Escolha o <strong>valor do voucher</strong> que deseja resgatar. Cada valor tem uma quantidade de pontos diferente.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-slate-800 mb-3 flex items-center gap-2">
                    <i className="ri-money-dollar-circle-line text-orange-500"></i>
                    Selecione o Valor
                  </h3>
                  <div className="grid grid-cols-2 gap-3">
                    {voucherSelecionado.valores.map((opcao: { label: string; pontos: number }) => {
                      const selecionado = valorVoucherSelecionado?.label === opcao.label;
                      const semPontos = pontosDisponiveis < opcao.pontos;
                      return (
                        <button
                          key={opcao.label}
                          onClick={() => !semPontos && setValorVoucherSelecionado(opcao)}
                          disabled={semPontos}
                          className={`flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all cursor-pointer ${
                            semPontos
                              ? 'border-slate-200 bg-slate-50 opacity-50 cursor-not-allowed'
                              : selecionado
                              ? 'border-orange-500 bg-orange-50 shadow-md'
                              : 'border-slate-200 hover:border-orange-300 hover:bg-orange-50/50'
                          }`}
                        >
                          <span className={`text-2xl font-bold mb-1 ${selecionado ? 'text-orange-600' : 'text-slate-800'}`}>
                            {opcao.label}
                          </span>
                          <span className={`text-xs font-medium ${selecionado ? 'text-orange-500' : 'text-slate-500'}`}>
                            {opcao.pontos.toLocaleString('pt-BR')} pts
                          </span>
                          {selecionado && (
                            <div className="mt-2 w-5 h-5 flex items-center justify-center rounded-full bg-orange-500">
                              <i className="ri-check-line text-white text-xs"></i>
                            </div>
                          )}
                          {semPontos && (
                            <span className="mt-1 text-xs text-red-400 flex items-center gap-1">
                              <i className="ri-lock-line"></i> Pontos insuficientes
                            </span>
                          )}
                        </button>
                      );
                    })}
                  </div>
                </div>

                <button
                  onClick={() => {
                    if (valorVoucherSelecionado) setEtapaResgateVoucher('contato');
                  }}
                  disabled={!valorVoucherSelecionado}
                  className="w-full py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Continuar
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            )}

            {/* ETAPA CONTATO */}
            {etapaResgateVoucher === 'contato' && (
              <div className="p-6 space-y-5">
                {/* Aviso de entrega digital */}
                <div className="flex items-start gap-3 bg-blue-50 border border-blue-200 rounded-xl p-4">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-information-line text-blue-500 text-xl"></i>
                  </div>
                  <p className="text-sm text-blue-700">
                    Vouchers são entregues <strong>digitalmente</strong>. Escolha pelo menos um canal de envio abaixo.
                  </p>
                </div>

                {/* Canais de envio */}
                <div>
                  <h3 className="font-semibold text-slate-800 mb-3 flex items-center gap-2">
                    <i className="ri-send-plane-line text-orange-500"></i>
                    Canais de Envio
                  </h3>
                  <div className="space-y-3">
                    {/* Email */}
                    <label className={`flex items-start gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all ${
                      contatoVoucher.canaisEnvio.email ? 'border-orange-400 bg-orange-50' : 'border-slate-200 hover:border-orange-200'
                    }`}>
                      <input
                        type="checkbox"
                        checked={contatoVoucher.canaisEnvio.email}
                        onChange={e => setContatoVoucher(prev => ({
                          ...prev,
                          canaisEnvio: { ...prev.canaisEnvio, email: e.target.checked }
                        }))}
                        className="mt-1 accent-orange-500 w-4 h-4 cursor-pointer"
                      />
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-orange-100 flex-shrink-0">
                        <i className="ri-mail-line text-orange-600 text-lg"></i>
                      </div>
                      <div className="flex-1">
                        <p className="font-semibold text-slate-800 text-sm mb-1">E-mail</p>
                        <input
                          type="email"
                          value={contatoVoucher.email}
                          onChange={e => setContatoVoucher(prev => ({ ...prev, email: e.target.value }))}
                          onClick={e => e.stopPropagation()}
                          placeholder="seu@email.com"
                          className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white"
                        />
                      </div>
                    </label>

                    {/* WhatsApp */}
                    <label className={`flex items-start gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all ${
                      contatoVoucher.canaisEnvio.whatsapp ? 'border-orange-400 bg-orange-50' : 'border-slate-200 hover:border-orange-200'
                    }`}>
                      <input
                        type="checkbox"
                        checked={contatoVoucher.canaisEnvio.whatsapp}
                        onChange={e => setContatoVoucher(prev => ({
                          ...prev,
                          canaisEnvio: { ...prev.canaisEnvio, whatsapp: e.target.checked }
                        }))}
                        className="mt-1 accent-orange-500 w-4 h-4 cursor-pointer"
                      />
                      <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-green-100 flex-shrink-0">
                        <i className="ri-whatsapp-line text-green-600 text-lg"></i>
                      </div>
                      <div className="flex-1">
                        <p className="font-semibold text-slate-800 text-sm mb-1">WhatsApp</p>
                        <input
                          type="tel"
                          value={contatoVoucher.whatsapp}
                          onChange={e => setContatoVoucher(prev => ({ ...prev, whatsapp: e.target.value }))}
                          onClick={e => e.stopPropagation()}
                          placeholder="(11) 99999-9999"
                          className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white"
                        />
                      </div>
                    </label>
                  </div>

                  {!contatoVoucher.canaisEnvio.email && !contatoVoucher.canaisEnvio.whatsapp && (
                    <p className="text-xs text-red-500 mt-2 flex items-center gap-1">
                      <i className="ri-error-warning-line"></i>
                      Selecione pelo menos um canal de envio.
                    </p>
                  )}
                </div>

                <div className="flex gap-3">
                  {voucherSelecionado.valores && (
                    <button
                      onClick={() => setEtapaResgateVoucher('valor')}
                      className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-arrow-left-line mr-2"></i>
                      Voltar
                    </button>
                  )}
                  <button
                    onClick={handleConfirmarContatoVoucher}
                    disabled={!contatoVoucher.canaisEnvio.email && !contatoVoucher.canaisEnvio.whatsapp}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                  >
                    Continuar
                    <i className="ri-arrow-right-line ml-2"></i>
                  </button>
                </div>
              </div>
            )}

            {/* ETAPA CONFIRMAÇÃO */}
            {etapaResgateVoucher === 'confirmacao' && (
              <div className="p-6 space-y-4">
                <h3 className="font-semibold text-slate-800 flex items-center gap-2">
                  <i className="ri-file-list-3-line text-orange-500"></i>
                  Confirmar Resgate
                </h3>

                {/* Seletor de Crédito */}
                {(() => {
                  const pontosNecessariosVoucher = valorVoucherSelecionado ? valorVoucherSelecionado.pontos : voucherSelecionado.pontos;
                  const creditoAtualVoucher = creditosFinanceiros.find(x => x.id === creditoSelecionadoVoucher);
                  const pontosCreditoVoucher = creditoAtualVoucher ? calcularPontosFinanceiro(creditoAtualVoucher.valor) : 0;
                  const creditosSuficientesVoucher = creditosFinanceiros.filter(c => calcularPontosFinanceiro(c.valor) >= pontosNecessariosVoucher);
                  return (
                    <div className="space-y-2">
                      <label className="block text-xs font-semibold text-slate-700">
                        <i className="ri-coin-line text-orange-500 mr-1"></i>
                        Crédito para desconto dos pontos
                      </label>
                      {creditosSuficientesVoucher.length === 0 ? (
                        <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                          <i className="ri-error-warning-fill text-red-500 text-lg mt-0.5 flex-shrink-0"></i>
                          <div>
                            <p className="text-sm font-semibold text-red-700">Nenhum crédito disponível</p>
                            <p className="text-xs text-red-600 mt-0.5">
                              Nenhum dos seus créditos possui saldo suficiente para este resgate. Necessário: <strong>{pontosNecessariosVoucher.toLocaleString('pt-BR')} pts</strong>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-1.5">
                          {creditosSuficientesVoucher.map(c => {
                            const pontosCredito = calcularPontosFinanceiro(c.valor);
                            const selecionado = creditoSelecionadoVoucher === c.id;
                            return (
                              <button
                                key={c.id}
                                type="button"
                                onClick={() => setCreditoSelecionadoVoucher(c.id)}
                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border-2 transition-all text-left cursor-pointer ${
                                  selecionado
                                    ? 'border-orange-500 bg-orange-50'
                                    : 'border-slate-200 hover:border-orange-300 hover:bg-orange-50/40'
                                }`}
                              >
                                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ${selecionado ? 'bg-orange-500' : 'bg-orange-100'}`}>
                                  {selecionado
                                    ? <i className="ri-check-line text-white text-sm"></i>
                                    : <i className="ri-medal-line text-orange-500 text-sm"></i>
                                  }
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm font-semibold truncate text-slate-800">{c.descricao}</p>
                                  <p className="text-xs truncate text-slate-500">{c.campanha}</p>
                                </div>
                                <div className="text-right flex-shrink-0">
                                  <p className="text-sm font-bold text-orange-600">{pontosCredito.toLocaleString('pt-BR')} pts</p>
                                  <p className="text-xs text-emerald-600">Saldo suficiente</p>
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      )}
                      {creditoSelecionadoVoucher && creditoAtualVoucher && (
                        <div className="bg-green-50 border border-green-200 rounded-xl px-3 py-2 flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill text-green-500"></i>
                            <span className="text-xs text-green-700 font-medium">Crédito selecionado</span>
                          </div>
                          <span className="text-xs text-green-700">
                            Saldo restante: <strong>{(pontosCreditoVoucher - pontosNecessariosVoucher).toLocaleString('pt-BR')} pts</strong>
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* Resumo de envio */}
                <div className="bg-slate-50 rounded-xl p-4 space-y-3">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Envio para</p>
                  {contatoVoucher.canaisEnvio.email && (
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-orange-100">
                        <i className="ri-mail-line text-orange-600"></i>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500">E-mail</p>
                        <p className="text-sm font-semibold text-slate-800">{contatoVoucher.email}</p>
                      </div>
                    </div>
                  )}
                  {contatoVoucher.canaisEnvio.whatsapp && (
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-100">
                        <i className="ri-whatsapp-line text-green-600"></i>
                      </div>
                      <div>
                        <p className="text-xs text-slate-500">WhatsApp</p>
                        <p className="text-sm font-semibold text-slate-800">{contatoVoucher.whatsapp}</p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Pontos */}
                <div className="bg-orange-50 rounded-xl p-4 border border-orange-200">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2">Pontos a debitar</p>
                  <div className="flex justify-between items-center">
                    <span className="text-slate-700">
                      {voucherSelecionado.nome}
                      {valorVoucherSelecionado && (
                        <span className="ml-2 text-xs font-semibold bg-orange-200 text-orange-700 px-2 py-0.5 rounded-full">
                          {valorVoucherSelecionado.label}
                        </span>
                      )}
                    </span>
                    <span className="text-xl font-bold text-orange-600">
                      {(valorVoucherSelecionado ? valorVoucherSelecionado.pontos : voucherSelecionado.pontos).toLocaleString('pt-BR')} pts
                    </span>
                  </div>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => setEtapaResgateVoucher('contato')}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-2"></i>
                    Voltar
                  </button>
                  <button
                    onClick={handleConfirmarResgateVoucher}
                    disabled={!creditoSelecionadoVoucher || (() => {
                      const c = creditosFinanceiros.find(x => x.id === creditoSelecionadoVoucher);
                      if (!c) return true;
                      const pts = valorVoucherSelecionado ? valorVoucherSelecionado.pontos : voucherSelecionado.pontos;
                      return calcularPontosFinanceiro(c.valor) < pts;
                    })()}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <i className="ri-shield-check-line mr-2"></i>
                    Confirmar e Verificar
                  </button>
                </div>
              </div>
            )}

            {/* ETAPA TOKEN */}
            {etapaResgateVoucher === 'token' && (
              <div className="p-6 space-y-5">
                {/* Ícone e título */}
                <div className="text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-shield-keyhole-line text-3xl text-orange-500"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-lg">Verificação de Segurança</h3>
                  <p className="text-sm text-slate-500 mt-1">
                    Enviamos um código de 6 dígitos para confirmar sua identidade.
                  </p>
                </div>

                {/* Canais de envio do token */}
                <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 space-y-2">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Código enviado para</p>
                  {contatoVoucher.canaisEnvio.email && (
                    <div className="flex items-center gap-2 text-sm text-slate-700">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-mail-check-line text-orange-500"></i>
                      </div>
                      <span>{contatoVoucher.email.replace(/(.{2})(.*)(@.*)/, '$1***$3')}</span>
                    </div>
                  )}
                  {contatoVoucher.canaisEnvio.whatsapp && (
                    <div className="flex items-center gap-2 text-sm text-slate-700">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-whatsapp-line text-green-500"></i>
                      </div>
                      <span>{contatoVoucher.whatsapp.replace(/(\(\d{2}\))\s?(\d{5})-?(\d{4})/, '$1 *****-$3')}</span>
                    </div>
                  )}
                </div>

                {/* Input do token */}
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-2">Código de verificação</label>
                  <input
                    type="text"
                    maxLength={6}
                    value={tokenVoucher}
                    onChange={e => {
                      setTokenVoucher(e.target.value.replace(/\D/g, '').slice(0, 6));
                      setTokenVoucherErro('');
                    }}
                    placeholder="000000"
                    className={`w-full px-4 py-3 border-2 rounded-xl text-center text-2xl font-bold tracking-[0.5em] focus:outline-none transition-all ${
                      tokenVoucherErro
                        ? 'border-red-400 bg-red-50 text-red-700'
                        : tokenVoucher.length === 6
                        ? 'border-green-400 bg-green-50 text-green-700'
                        : 'border-slate-200 focus:border-orange-400'
                    }`}
                  />
                  {tokenVoucherErro && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                      <i className="ri-error-warning-line"></i>
                      {tokenVoucherErro}
                    </p>
                  )}
                </div>

                {/* Reenviar código */}
                <div className="text-center">
                  {reenvioCountdownVoucher > 0 ? (
                    <p className="text-sm text-slate-400">
                      Reenviar código em <span className="font-semibold text-orange-500">{reenvioCountdownVoucher}s</span>
                    </p>
                  ) : (
                    <button
                      onClick={handleReenviarTokenVoucher}
                      className="text-sm text-orange-500 hover:text-orange-700 font-medium cursor-pointer transition-colors"
                    >
                      <i className="ri-refresh-line mr-1"></i>
                      Reenviar código
                    </button>
                  )}
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => setEtapaResgateVoucher('confirmacao')}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-2"></i>
                    Voltar
                  </button>
                  <button
                    onClick={handleValidarTokenVoucher}
                    disabled={tokenVoucher.length !== 6}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-check-line mr-2"></i>
                    Validar e Concluir
                  </button>
                </div>
              </div>
            )}

            {/* ETAPA SUCESSO */}
            {etapaResgateVoucher === 'sucesso' && (
              <div className="p-8 text-center space-y-5">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-checkbox-circle-fill text-5xl text-green-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-1">Voucher Enviado! 🎉</h3>
                  <p className="text-slate-500 text-sm">Seu voucher foi gerado e enviado com sucesso.</p>
                </div>

                {/* Código do voucher */}
                <div className="bg-slate-50 rounded-xl p-4 text-left space-y-3">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Código do Voucher</p>
                  <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg px-3 py-2">
                    <i className="ri-coupon-line text-orange-500"></i>
                    <span className="font-mono text-sm font-bold text-slate-800 flex-1 tracking-widest">{codigoVoucherGerado}</span>
                    <button
                      onClick={() => navigator.clipboard?.writeText(codigoVoucherGerado)}
                      className="text-slate-400 hover:text-orange-500 transition-colors cursor-pointer"
                      title="Copiar código"
                    >
                      <i className="ri-file-copy-line"></i>
                    </button>
                  </div>

                  {/* Canais enviados */}
                  <div className="space-y-2">
                    <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Enviado via</p>
                    {contatoVoucher.canaisEnvio.email && (
                      <div className="flex items-center gap-2 text-sm text-slate-700">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <i className="ri-mail-check-line text-orange-500"></i>
                        </div>
                        <span>E-mail: <strong>{contatoVoucher.email}</strong></span>
                      </div>
                    )}
                    {contatoVoucher.canaisEnvio.whatsapp && (
                      <div className="flex items-center gap-2 text-sm text-slate-700">
                        <div className="w-6 h-6 flex items-center justify-center">
                          <i className="ri-whatsapp-line text-green-500"></i>
                        </div>
                        <span>WhatsApp: <strong>{contatoVoucher.whatsapp}</strong></span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={handleFecharModalVoucher}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Fechar
                  </button>
                  <button
                    onClick={handleVerResgatesVoucher}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-history-line mr-2"></i>
                    Ver Meus Resgates
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal de Resgate Genérico — Experiências e Cursos */}
      {modalResgateGenerico && itemGenericoSelecionado && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-lg w-full overflow-hidden shadow-2xl animate-[scaleIn_0.3s_ease-out]">

            {/* Header */}
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <i className={`${tipoItemGenerico === 'curso' ? 'ri-graduation-cap-line' : 'ri-compass-3-line'} text-white text-xl`}></i>
                </div>
                <div>
                  <h2 className="text-lg font-bold text-white">
                    Resgatar {tipoItemGenerico === 'curso' ? 'Curso' : 'Experiência'}
                  </h2>
                  <p className="text-orange-100 text-xs">
                    {etapaGenerico === 'credito' && 'Passo 1 de 2 — Selecione o crédito'}
                    {etapaGenerico === 'token' && 'Passo 2 de 2 — Verificação de segurança'}
                    {etapaGenerico === 'sucesso' && 'Resgate confirmado!'}
                  </p>
                </div>
              </div>
              {etapaGenerico !== 'sucesso' && (
                <button onClick={handleFecharModalGenerico} className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-close-line text-white text-lg"></i>
                </button>
              )}
            </div>

            {/* Item resumo */}
            {etapaGenerico !== 'sucesso' && (
              <div className="flex items-center gap-4 px-6 py-4 bg-orange-50 border-b border-orange-100">
                <img src={itemGenericoSelecionado.imagem} alt={itemGenericoSelecionado.nome} className="w-16 h-16 object-cover rounded-xl border border-orange-200" />
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-slate-900 truncate">{itemGenericoSelecionado.nome}</p>
                  <p className="text-sm text-slate-500 truncate">{itemGenericoSelecionado.descricao}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-lg font-bold text-slate-900">{itemGenericoSelecionado.pontos.toLocaleString('pt-BR')}</p>
                  <p className="text-xs text-slate-500">pontos</p>
                </div>
              </div>
            )}

            {/* ETAPA CRÉDITO */}
            {etapaGenerico === 'credito' && (
              <div className="p-6 space-y-5">
                <div className="flex items-start gap-3 bg-orange-50 border border-orange-200 rounded-xl p-4">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-information-line text-orange-500 text-xl"></i>
                  </div>
                  <p className="text-sm text-orange-700">
                    Selecione de qual <strong>crédito</strong> os pontos serão descontados para este resgate.
                  </p>
                </div>

                {(() => {
                  const pontosNecessariosGen = itemGenericoSelecionado.pontos;
                  const creditoAtualGen = creditosFinanceiros.find(x => x.id === creditoSelecionadoGenerico);
                  const pontosCreditoGen = creditoAtualGen ? calcularPontosFinanceiro(creditoAtualGen.valor) : 0;
                  const creditosSuficientesGen = creditosFinanceiros.filter(c => calcularPontosFinanceiro(c.valor) >= pontosNecessariosGen);
                  return (
                    <div className="space-y-2">
                      <label className="block text-xs font-semibold text-slate-700">
                        <i className="ri-coin-line text-orange-500 mr-1"></i>
                        Crédito para desconto dos pontos
                      </label>
                      {creditosSuficientesGen.length === 0 ? (
                        <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                          <i className="ri-error-warning-fill text-red-500 text-lg mt-0.5 flex-shrink-0"></i>
                          <div>
                            <p className="text-sm font-semibold text-red-700">Nenhum crédito disponível</p>
                            <p className="text-xs text-red-600 mt-0.5">
                              Nenhum dos seus créditos possui saldo suficiente para este resgate. Necessário: <strong>{pontosNecessariosGen.toLocaleString('pt-BR')} pts</strong>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <div className="space-y-1.5">
                          {creditosSuficientesGen.map(c => {
                            const pontosCredito = calcularPontosFinanceiro(c.valor);
                            const selecionado = creditoSelecionadoGenerico === c.id;
                            return (
                              <button
                                key={c.id}
                                type="button"
                                onClick={() => setCreditoSelecionadoGenerico(c.id)}
                                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border-2 transition-all text-left cursor-pointer ${
                                  selecionado
                                    ? 'border-orange-500 bg-orange-50'
                                    : 'border-slate-200 hover:border-orange-300 hover:bg-orange-50/40'
                                }`}
                              >
                                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 ${selecionado ? 'bg-orange-500' : 'bg-orange-100'}`}>
                                  {selecionado
                                    ? <i className="ri-check-line text-white text-sm"></i>
                                    : <i className="ri-medal-line text-orange-500 text-sm"></i>
                                  }
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm font-semibold truncate text-slate-800">{c.descricao}</p>
                                  <p className="text-xs truncate text-slate-500">{c.campanha}</p>
                                </div>
                                <div className="text-right flex-shrink-0">
                                  <p className="text-sm font-bold text-orange-600">{pontosCredito.toLocaleString('pt-BR')} pts</p>
                                  <p className="text-xs text-emerald-600">Saldo suficiente</p>
                                </div>
                              </button>
                            );
                          })}
                        </div>
                      )}
                      {creditoSelecionadoGenerico && creditoAtualGen && (
                        <div className="bg-green-50 border border-green-200 rounded-xl px-3 py-2 flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <i className="ri-checkbox-circle-fill text-green-500"></i>
                            <span className="text-xs text-green-700 font-medium">Crédito selecionado</span>
                          </div>
                          <span className="text-xs text-green-700">
                            Saldo restante: <strong>{(pontosCreditoGen - pontosNecessariosGen).toLocaleString('pt-BR')} pts</strong>
                          </span>
                        </div>
                      )}
                    </div>
                  );
                })()}

                <button
                  onClick={handleConfirmarCreditoGenerico}
                  disabled={!creditoSelecionadoGenerico || (() => {
                    const c = creditosFinanceiros.find(x => x.id === creditoSelecionadoGenerico);
                    if (!c) return true;
                    return calcularPontosFinanceiro(c.valor) < itemGenericoSelecionado.pontos;
                  })()}
                  className="w-full py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <i className="ri-shield-check-line mr-2"></i>
                  Confirmar e Verificar
                </button>
              </div>
            )}

            {/* ETAPA TOKEN */}
            {etapaGenerico === 'token' && (
              <div className="p-6 space-y-5">
                <div className="text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-shield-keyhole-line text-3xl text-orange-500"></i>
                  </div>
                  <h3 className="font-bold text-slate-900 text-lg">Verificação de Segurança</h3>
                  <p className="text-sm text-slate-500 mt-1">Enviamos um código de 6 dígitos para confirmar sua identidade.</p>
                </div>

                {/* Resumo do crédito */}
                {(() => {
                  const c = creditosFinanceiros.find(x => x.id === creditoSelecionadoGenerico);
                  if (!c) return null;
                  return (
                    <div className="bg-orange-50 border border-orange-200 rounded-xl px-4 py-3 flex items-center gap-3">
                      <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                        <i className="ri-medal-line text-orange-500 text-lg"></i>
                      </div>
                      <div className="flex-1">
                        <p className="text-xs font-semibold text-orange-800">{c.descricao}</p>
                        <p className="text-xs text-orange-600">Campanha: {c.campanha}</p>
                      </div>
                      <span className="text-sm font-bold text-orange-600">{itemGenericoSelecionado.pontos.toLocaleString('pt-BR')} pts</span>
                    </div>
                  );
                })()}

                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-2">Código de verificação</label>
                  <input
                    type="text"
                    maxLength={6}
                    value={tokenGenerico}
                    onChange={e => {
                      setTokenGenerico(e.target.value.replace(/\D/g, '').slice(0, 6));
                      setTokenGenericoErro('');
                    }}
                    placeholder="000000"
                    className={`w-full px-4 py-3 border-2 rounded-xl text-center text-2xl font-bold tracking-[0.5em] focus:outline-none transition-all ${
                      tokenGenericoErro
                        ? 'border-red-400 bg-red-50 text-red-700'
                        : tokenGenerico.length === 6
                        ? 'border-green-400 bg-green-50 text-green-700'
                        : 'border-slate-200 focus:border-orange-400'
                    }`}
                  />
                  {tokenGenericoErro && (
                    <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                      <i className="ri-error-warning-line"></i>
                      {tokenGenericoErro}
                    </p>
                  )}
                </div>

                <div className="text-center">
                  {reenvioCountdownGenerico > 0 ? (
                    <p className="text-sm text-slate-400">
                      Reenviar código em <span className="font-semibold text-orange-500">{reenvioCountdownGenerico}s</span>
                    </p>
                  ) : (
                    <button
                      onClick={() => { setTokenGenerico(''); setTokenGenericoErro(''); setReenvioCountdownGenerico(60); }}
                      className="text-sm text-orange-500 hover:text-orange-700 font-medium cursor-pointer transition-colors"
                    >
                      <i className="ri-refresh-line mr-1"></i>
                      Reenviar código
                    </button>
                  )}
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => setEtapaGenerico('credito')}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-2"></i>
                    Voltar
                  </button>
                  <button
                    onClick={handleValidarTokenGenerico}
                    disabled={tokenGenerico.length !== 6}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <i className="ri-check-line mr-2"></i>
                    Validar e Concluir
                  </button>
                </div>
              </div>
            )}

            {/* ETAPA SUCESSO */}
            {etapaGenerico === 'sucesso' && (
              <div className="p-8 text-center space-y-5">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-checkbox-circle-fill text-5xl text-green-500"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-1">
                    {tipoItemGenerico === 'curso' ? 'Curso Liberado!' : 'Experiência Confirmada!'} 🎉
                  </h3>
                  <p className="text-slate-500 text-sm">
                    {tipoItemGenerico === 'curso'
                      ? 'Seu acesso ao curso foi liberado com sucesso.'
                      : 'Sua experiência foi reservada com sucesso.'}
                  </p>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 text-left space-y-2">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Detalhes do Resgate</p>
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-600">Item</span>
                    <span className="font-semibold text-slate-800">{itemGenericoSelecionado.nome}</span>
                  </div>
                  {(() => {
                    const c = creditosFinanceiros.find(x => x.id === creditoSelecionadoGenerico);
                    if (!c) return null;
                    return (
                      <>
                        <div className="flex justify-between text-sm">
                          <span className="text-slate-600">Crédito utilizado</span>
                          <span className="font-semibold text-slate-800">{c.descricao}</span>
                        </div>
                        <div className="flex justify-between text-sm">
                          <span className="text-slate-600">Campanha</span>
                          <span className="font-medium text-slate-700">{c.campanha}</span>
                        </div>
                      </>
                    );
                  })()}
                  <div className="flex justify-between text-sm border-t border-slate-200 pt-2">
                    <span className="text-slate-600 font-semibold">Pontos debitados</span>
                    <span className="font-bold text-orange-600">{itemGenericoSelecionado.pontos.toLocaleString('pt-BR')} pts</span>
                  </div>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={handleFecharModalGenerico}
                    className="flex-1 py-3 bg-slate-100 text-slate-700 rounded-xl font-semibold hover:bg-slate-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Fechar
                  </button>
                  <button
                    onClick={() => { handleFecharModalGenerico(); setAbaSelecionada('resgates'); }}
                    className="flex-1 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-history-line mr-2"></i>
                    Ver Meus Resgates
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal Cashback */}
      {modalCashbackAberto && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden animate-[scaleIn_0.3s_ease-out]">
            <div className="bg-gradient-to-br from-purple-500 to-purple-600 p-6 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-percent-line text-4xl text-white"></i>
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Cashback</h2>
              <p className="text-white/90 text-sm">Acumule pontos nas suas compras</p>
            </div>

            <div className="p-6">
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-purple-800 text-center">
                  <i className="ri-information-line mr-2"></i>
                  Funcionalidade em breve! Você poderá receber cashback em suas compras e acumular ainda mais pontos.
                </p>
              </div>

              <button
                onClick={() => setModalCashbackAberto(false)}
                className="w-full px-6 py-3 bg-slate-200 text-slate-700 rounded-lg font-semibold hover:bg-slate-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Comprovante — gerenciado dentro de MeusResgates */}

      <style>{`
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}
